import SessionDataStore from "./SessionDataStoreController";
import Util from "./Util";
import Const from "../constants/Constants";
import axios from "axios";
import RTMConst from "../constants/Rtmconstants";
import {browserName as browName, isSafari as safari, isChrome as chrome, osName as osname, isTablet as tablete, isFirefox as is_ffox } from "react-device-detect";
import hostlanguage from '../services/contentData';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { loadWhiteboard } from '../utils/whiteboard';
import shareScreen from "../utils/shareScreen";
import whiteboard from "../utils/whiteboardNew";
import roomSetup from "../utils/roomSetup";
import audioPlay from "../utils/audioPlay";

function preStreaming(){
	
	window.document.title = 'Virdio Live Streaming';
	  
	window['RTM_attempts'] = 0;
	
    var $ = window.$ || {}
    var AgoraRTM = window.AgoraRTM;
	  var AgoraRTC = window.AgoraElectron ? window.AgoraElectron : window.AgoraRTC;
    var sessionDataStore = SessionDataStore.getInstance();

    if(!AgoraRTC.checkSystemRequirements()) {
      alert("Your browser does not support WebRTC!");
    }

    var currentUserData = JSON.parse(localStorage.getItem("userData"));
	
	if ( JSON.parse(localStorage.getItem('tutorialData')) && JSON.parse(localStorage.getItem('tutorialData')).sessionId != currentUserData.sessionData.id )
		{
			localStorage.removeItem('tutorialData');
		}
		
	var userDataObj = currentUserData;
	if ( currentUserData.sessionData.ondemandId > 0 || currentUserData.userType == 1 )
		{
			if ( localStorage.getItem('turnOfCamera') ) { localStorage.removeItem('turnOfCamera'); }
			
			if ( currentUserData.sessionData.ondemandId > 0 ) { currentUserData.userType = 2; }
			
			/*if ( currentUserData.userType == 2 )
				{
					delete userDataObj.userType;
					currentUserData = userDataObj;
					localStorage.setItem('userData', JSON.stringify(userDataObj));
				}*/
		}
		
	window['currentUserData'] = currentUserData;
    var newclient,
        channel,
        main_mic_id;

    var sep = '~@$';
    var newArr121 = [],
        newArr122 = [],
        retryCounter = 0,
        countRef = null,
        isCameraDetected = false,
        isMicrophoneDetected = false,
        msgOne = null,
        msgTwo = null,
        checkOnlineInterval = null,
        isOnline = true,
        hasSessionStarted = false,
        changeSettingInterval = null,
        hostRTMConnected = false,
		    isFoundEquipment = false,
        roomSetupStatus = currentUserData.sessionData.turnoffRoomSetup;

    var rtmAppId = currentUserData.rtmAppId,
        channelName1 = currentUserData.sessionData.rtmChannelId,
        token = null,
        peer = currentUserData.email;
	
	var newCameraArray = [];
	var globalCameraId;
	var localStreamOnDemand = null;
	var streamStatus = false;
	
    var audio = new Audio('./audio/notify.mp3');
    localStorage.removeItem('video-resolution');
    localStorage.removeItem('cameraAccessAllowed');
    localStorage.removeItem('microphoneAccessAllowed');
    localStorage.removeItem('broadCaster');
    localStorage.removeItem('recordingStarted');
	window['userWhiteboard'] = {};
	window['scriptLoaded'] = false;
	window['workoutConePlacing'] = {};
	
	if ( window['electron'] )
		{
			window['deviceNotSupported'+currentUserData.id] = false;
			window['deviceNotSupported'] = false;
		}
	else
		{	
			window['deviceNotSupported'+currentUserData.id] = true;
			window['deviceNotSupported'] = true;
		}
	
	var soundPlay = window.soundPlay ? window.soundPlay : new audioPlay();
	window.soundPlay = soundPlay;
	
    function getTempUsers(){
	console.log('preStreamingController---8.3');
      return localStorage.getItem("tempUsers") != undefined ? JSON.parse(localStorage.getItem("tempUsers")) : [];
    }
	console.log('preStreamingController---8.4');

    function convertEmailToId(email){
	console.log('preStreamingController---8.5');
      let userList = getTempUsers();
	console.log('preStreamingController---8.6');

      if(userList != ''){
		  
	console.log('preStreamingController---8.7');
        for(let i= 0; i < userList.length; i++){
          if(userList[i].email == email){
            return userList[i].id;
          }
        }
	console.log('preStreamingController---8.8');
        return 0;
      } else {
        console.log('Invalid access ');
        return 0;
      }
    }
	console.log('preStreamingController---8.9');
	
	function checkEquipment() {
	console.log('preStreamingController---8.10');
		var activity = currentUserData.sessionData.scriptDetail;
	console.log('preStreamingController---8.11', activity);
		if ( activity && activity.length )
			{
	console.log('preStreamingController---8.12');
				for ( var i = 0; i < activity.length; i++ )
					{
						for ( var a = 0; a < activity[i].attribute.length; a++ )
							{
								if ( activity[i].attribute[a].attrLabel === 'Activity Type' )
									{
										if ( activity[i].attribute[a].attrValue === 'Virtual Assistant' || activity[i].attribute[a].attrValue === 'Virtual Equipment' )
											{
												isFoundEquipment = true;
											}
									}
							}
					}
	console.log('preStreamingController---8.13');
			}
	console.log('preStreamingController---8.14');
		checkRoomSetupStatus(0);
	console.log('preStreamingController---8.15');
	}
	
	checkEquipment();
	
    window.rtmJoin = () => {
      console.log('window.rtmJoin');
      newclient = AgoraRTM.createInstance(rtmAppId, { enableLogUpload: false, logFilter: AgoraRTM.LOG_FILTER_OFF });
      window.newclient = newclient;

      newclient.on('MessageFromPeer', (message, peerId) => { 
          var msg = message.text;
		  console.log(message, peerId, currentUserData.userType);
          window.signalHandler(peerId, msg, currentUserData.userType);
          console.log('MessageFromPeer - ', msg, peerId);
      });

      newclient.on('ConnectionStateChanged', (newState, reason) => {
        
          console.log('connectionstate changed to: ' + newState + ' reason: ' + reason);

          if (reason == 'REMOTE_LOGIN') {
              newclient.logout();
              $('#multi-media-access-alert').modal('hide');
              $('#multi-device-login-alert').modal('show');
             window.logoutRemoteUser();

              let addObject = {"sessionId": currentUserData.sessionData.id, "event": "status", "eventType": "logout", "userId": currentUserData.id, "details": JSON.stringify({"status":"success", "msg": "Remote Login"}), "timestamp": Util.getCurrentTimestamp()};
              sessionDataStore.addSessionData(addObject);
          } else {          
              if ((newState == 'ABORTED' || newState == 'DISCONNECTED') && (reason == 'LOGIN_TIMEOUT' || reason == 'INTERRUPTED' || reason == 'REMOTE_LOGIN' || reason == 'LOGIN_FAILURE' || reason == 'BANNED_BY_SERVER')) {
                  newclient.logout(); 
                  setTimeout(doClientLogin, 500);
              }
          }
      });

      doClientLogin();
    }
	
	function checkRoomSetupStatus(mod){
		var isFoundEquipment = false;
		var localstoragedata = JSON.parse(localStorage.getItem('userData'));
		var activity = localstoragedata.sessionData.scriptDetail;
		
		if ( activity && activity.length > 0 )
			{
				for ( var i = 0; i < activity.length; i++ )
					{
						for ( var a = 0; a < activity[i].attribute.length; a++ )
							{
								if ( activity[i].attribute[a].attrLabel === 'Activity Type' )
									{
										if ( activity[i].attribute[a].attrValue === 'Virtual Assistant' || activity[i].attribute[a].attrValue === 'Virtual Equipment' )
											{
												isFoundEquipment = true;
											}
									}
							}
					}
			}
		
		
			
		 setTimeout( function (){
			if ( currentUserData.isMarketplaceChannel == 0 )
				{
					if ( mod == 1 )
						{
							//$('.pre-click-zoom').addClass('d-none');
						}
					else if ( mod == 0 )
						{
							//$('.pre-click-zoom').removeClass('d-none');
						}
				}
			else
				{
					if ( ( currentUserData.userType == 1 || parseInt(currentUserData.default.WASRequiredInWaitingLounge) == 1 ) && isFoundEquipment )
						{
							//$('.pre-click-zoom').removeClass('d-none');
							$('#camera_cbx').removeClass('camera_main_holder');
						}
				}
		},1000);			
	}
	
	function checkHostPlaylist()
	{
		let userData = JSON.parse(localStorage.getItem('userData'));
		if ( userData.userType == 1 )
			{
				let uSessionData = userData.sessionData;
				if ( uSessionData.playlist && uSessionData.playlist.length > 0 )
					{
						localStorage.removeItem('forceHidePlaylist');
						var wrongBrowser = false;
						if ( window['electron'] && uSessionData.playlist[0]['browser'] !== 'Native App' && uSessionData.playlist[0]['browser'] !== 'Native Windows' && uSessionData.playlist[0]['browser'] !== 'Native Mac OS' )
							{
								wrongBrowser = true;
							}
						else if ( !window['electron'] && uSessionData.playlist[0]['browser'] !== browName )
							{
								wrongBrowser = true;
							}
						
						if ( wrongBrowser )
							{
								if ( userData.showCompleteBodyAlert == 0 ) { window.$('#no-playlist-found').modal('show'); }
								localStorage.setItem('forceHidePlaylist', true);
							}
						else
							{
								if ( !window['electron'] && uSessionData.playlist[0]['browser'] == browName && window['getSongById'] )
									{
										window['getSongById'](uSessionData.playlist[0]['songs'][0]['fileName']);
									}
								
								if ( window['electron'] && ( uSessionData.playlist[0]['browser'] == 'Native App' || uSessionData.playlist[0]['browser'] == 'Native Windows' || uSessionData.playlist[0]['browser'] == 'Native Mac OS' ) && window['fsFile'] )
									{
										if ( window['fsFile'].existsSync(uSessionData.playlist[0]['songs'][0]['fileName']) == false )
											{
												if ( userData.showCompleteBodyAlert == 0 ) { window.$('#no-playlist-found').modal('show'); }
												localStorage.setItem('forceHidePlaylist', true);
											}
									}
							}
					}
			}
	}
		

    function doClientLogin()
    {
		console.log('doClientLogin PreStreaming Controler');
      newclient.login({ token: token, uid: peer }).then(() => {
		  
		  console.log('channelName1************************************');
		  console.log(channelName1);
		  
          channel = newclient.createChannel(channelName1);
          window.channel = channel;
		  
          channel.join().then(() => {
              console.log('channel.join****************************************');         
              if ( !hostRTMConnected ) { hostRTMConnected = true; }
              window.rtmConnected();

              var text = RTMConst.JOINED + sep;
              channel.sendMessage({text}).then(() => {
                  console.log('message send successfully on channel------');
              }).catch(error => {
                  console.log('-------Unable to send channel message------', error);
                  let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "error", "userId": currentUserData.id, "details": JSON.stringify({"status": "fail", "type": "Channel message(208) fails to be sent", "msg": error}), "timestamp": Util.getCurrentTimestamp()};
                  sessionDataStore.addSessionData(addObject);
              });
			  
			  let addObject = {"sessionId": currentUserData.sessionData.id, "event": "status", "eventType": "waitingLoungeEnter", "userId": currentUserData.id, "details": JSON.stringify({"msg": "The user entered the Waiting Lounge"}), "timestamp": Util.getCurrentTimestamp()};
			  sessionDataStore.addSessionData(addObject);
			  if ( currentUserData.userType == 2 )
				  {
					sendMessage(currentUserData.sessionData.hostEmail, "checkIsStarted");
					
					if ( currentUserData.isMarketplaceChannel && currentUserData.isMarketplaceChannel == 1 )
						{
							let sep = '~@$';
							window['memberState'] = 'joinWaitingLounge';
							let msg = RTMConst.MEMBER_ONLINE+sep+window['memberState']+sep+currentUserData.id;
							sendMessage(currentUserData.sessionData.hostEmail, msg);
						}
				  }

              channel.on('MemberJoined', memberId => {

                  console.log('Member joined - ' + memberId);
				  
				  if ( memberId == currentUserData.sessionData.hostEmail && currentUserData.isMarketplaceChannel && currentUserData.isMarketplaceChannel == 1 )
					  {	
						  let sep = '~@$';
						  let msg = RTMConst.MEMBER_ONLINE+sep+window['memberState']+sep+currentUserData.id;
						  sendMessage(currentUserData.sessionData.hostEmail, msg);
					  }

                  let remoteUser = memberId.includes("RM-");
                  let userExists = true;
					
                  if (remoteUser === false) {
                      userExists = window.checkSessionUser(memberId);
                  }
                  if (userExists === true) {
                      if (remoteUser === false) {

                          let userId = convertEmailToId(memberId);
                          
                          window.updateStatusMember(userId, 'online');
						   if ( window.getSessionUsersChat )
								{
									window.getSessionUsersChat();
								}

                          if (currentUserData.userType == Const.USER_TYPE.PARTICIPANT) {
                              addUserAttribute(userId, 'currentStatus', 1);
							  
							  if ( memberId == currentUserData.sessionData.hostEmail )
								  {	
									if ( window['userWhiteboard'] && window['userWhiteboard'][currentUserData.id] && window['userWhiteboard'][currentUserData.id].roomSetup.workoutAreaSetupDone )
										{
											var sep = '~@$';
											var message = 'preStreamingRoomSetup'+sep+JSON.stringify(window['userWhiteboard'][currentUserData.id].roomSetup.workoutConeLocation);
											window['userWhiteboard'][currentUserData.id].splitRTMSend(currentUserData.sessionData.hostEmail, message);
										}
								  }
                          }

                          if(currentUserData.userType == Const.USER_TYPE.HOST){
                            if( $('#joinee-' + userId).length == 0 ){
                                let joinerName = getUserDataFromList(memberId, 'firstName')+' '+(getUserDataFromList(memberId, 'lastName') != null?getUserDataFromList(memberId, 'lastName'):'');
                                $('#joiners').append('<p class="text-white" id="joinee-'+userId+'">'+joinerName+'</p>');
                                if (!currentUserData.isMarketplaceChannel || (currentUserData.isMarketplaceChannel && currentUserData.isMarketplaceChannel == 0))
									{
										window.play_notification_sound();
									}
                            }
                          }

                          var massages = RTMConst.JOINED+sep+memberId+sep+"joined"+sep;        
                          window.channelSignalHandler(JSON.stringify({code:RTMConst.JOINED,member:memberId, message:massages,msgtype:"Joined"}), currentUserData.userType);
                      }
                  } else {
                      var userData = {
                          email : memberId
                      };

                      return new Promise((resolve, reject) => {
                          axios.post(process.env.REACT_APP_API_URL+"/api/v1/user/checkUserExist", userData)
                          .then(res => {

                              console.log('Member joined - not exists - ', window.pendingUsers);

                              let userId = res.data.responseData.id;

                              res.data.responseData.userType = 2;
                              res.data.responseData.sessionStatus = 0;
                              res.data.responseData.isOnline = true;

                              if ( !res.data.responseData.image || res.data.responseData.image == 'null' || ( res.data.responseData.image !== '' && res.data.responseData.image.indexOf('.s3') == -1 ) )
                              {
                                res.data.responseData.image = './images/user_avatar.svg';
                              }
								window.addToSessionUsers(res.data.responseData);

                              $('#totalsignup').text(parseInt($('#totalsignup').text())+1);

                              if (currentUserData.userType == Const.USER_TYPE.PARTICIPANT) {
								  window.updateStatusMember(userId, 'online');
                                  addUserAttribute(userId, 'currentStatus', 1);
								  if ( window.getSessionUsersChat )
									{
										window.getSessionUsersChat();
									}
                              }

                              if (window.pendingUsers && window.pendingUsers.length > 0) {
                                  let userLength = window.pendingUsers.length;

                                  for (let i = 0; i < userLength; i++) {
                                      if (window.pendingUsers[i].senderId == memberId) {
										  console.log(window.pendingUsers[i].message.text);
										  console.log(memberId);
                                          window.channelMsgHandler(window.pendingUsers[i].message.text, memberId, currentUserData.userType);
                                          window.pendingUsers.splice(i, 1);
                                      }
                                  }
                              }

                              if(currentUserData.userType == Const.USER_TYPE.HOST && remoteUser == false) {
                                if( $('#joinee-' + userId).length == 0 ) {
                                    let joinerName = getUserDataFromList(memberId, 'firstName')+' '+(getUserDataFromList(memberId, 'lastName') != null?getUserDataFromList(memberId, 'lastName'):'');
                                    $('#joiners').append('<p class="text-white" id="joinee-'+userId+'">'+joinerName+'</p>');
                                    
									if (!currentUserData.isMarketplaceChannel || (currentUserData.isMarketplaceChannel && currentUserData.isMarketplaceChannel == 0))
										{
											window.play_notification_sound();
										}
                                }
                              }

                              var massages = RTMConst.JOINED+sep+memberId+sep+"joined"+sep;        
                              window.channelSignalHandler(JSON.stringify({code:RTMConst.JOINED,member:memberId, message:massages,msgtype:"Joined"}), currentUserData.userType);
                          }).catch(err => {
                              console.log('checkuser error === ', err);
                          }
                        );
                      });
                  }
              });
       
              channel.on('MemberLeft', memberId => {

                  console.log('Member left - ' + memberId);

                  if (memberId.includes("RM-") === false) {

                      var massages = RTMConst.JOINED+sep+memberId+sep+"left"+sep;  
                      window.channelSignalHandler(JSON.stringify({code:RTMConst.JOINED,member:memberId, message:massages,msgtype:"left"}), currentUserData.userType);
                    
                      let userId = convertEmailToId(memberId);

                      window.updateStatusMember(userId, 'offline');
                      window.onMemberLeft(memberId);

                      if(currentUserData.userType == Const.USER_TYPE.HOST){
                          if( $('#joinee-' + userId).length != 0 ){
                              $('#joiners').find("#joinee-"+userId).remove();
                          }

                          setTimeout(function(){
                              let text = "1100" + sep;
                              checkAvailableAtRTM(memberId, text);
                          }, 10000);
                      }

                      if (currentUserData.userType == Const.USER_TYPE.PARTICIPANT)
                      {
                          removeUserAttribute(userId, 'currentStatus');
                      }
                      else
                      {
                          removeUserAttribute(userId, 'cameraAccess');
                          removeUserAttribute(userId, 'micAccess');
                      }
                  }
              });
       
              channel.on('ChannelMessage', window.onChannelMessage);

              channel.on('MemberCountUpdated', (memberCount) => {
                  console.log('MemberCountUpdated - ', memberCount);
              });
          }).catch(error => {
              console.log('Channel join error - ', error);
              let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "error", "userId": currentUserData.id, "details": JSON.stringify({"status": "fail", "type": "RTM Channel Join", "msg": error}), "timestamp": Util.getCurrentTimestamp()};
              sessionDataStore.addSessionData(addObject);
          });
      }).catch(err => {
          if( err.code == 9 )
          {
              doClientLogin();
          }
		  
		if ( !window['RTM_attempts'] ) { window['RTM_attempts'] = 0; }
		window['RTM_attempts']++;
		
		if ( window['RTM_attempts'] == 3 && currentUserData.userType == 2 ) { $('#participant_stuck_msg').modal('show'); }
		  
          console.error('RTM login error - ', err);

          let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.STATUS, "eventType": "error", "userId": currentUserData.id, "details": JSON.stringify({"status": "fail", "type": "RTM Login", "msg": err}), "timestamp": Util.getCurrentTimestamp()};
          sessionDataStore.addSessionData(addObject);
      });
    }

    function leave_channel() {
      $('.modal').modal('hide');
		
		window.removePreScreenSession();
		
		if ( audioTest ) { audioTest.pause(); }
	  
	  if ( newclient != undefined )
      {
          if ( channel != undefined )
          {
              channel.leave();
          }

          newclient.logout().then(() => {
              console.log('logout success');
			  goToHome();
          }).catch(err => {
              console.log('RTM logout error - ', err);
              goToHome();
          });
      }
      else
      {
         goToHome();
      }
    }
	
	function goToHome(){
		if ( localStorage.getItem('currentUser') && localStorage.getItem('currentUserToken') )
			{
				let userId = localStorage.getItem('currentUser');
				let userToken = localStorage.getItem('currentUserToken');
				if ( window['loginAsOtherUser'] )
					{
						window['loginAsOtherUser'](userId, userToken).then((response) => {
							localStorage.setItem("userData", JSON.stringify(response));
							localStorage.removeItem('currentUser');
							localStorage.removeItem('currentUserToken');
							if ( window['openOndemandFromBookmark'] )
								{
									window['openOndemandFromBookmark'] = false;
									window['propsHistory'].push('/home#myScheduleAndBookmark');
								}
							else 
								{
									window['openOndemandFromBookmark'] = false;
									window['propsHistory'].push('/home');
								}								
							
					  }).catch(error => {
					  });
					}
				else
					{
						if ( window['openOndemandFromBookmark'] )
							{
								window['openOndemandFromBookmark'] = false;
								window['propsHistory'].push('/home#myScheduleAndBookmark');
							}
						else 
							{
								window['openOndemandFromBookmark'] = false;
								window['propsHistory'].push('/home');
							}							
						
					}
			}
		else
			{
				if ( window['openOndemandFromBookmark'] )
					{
						window['openOndemandFromBookmark'] = false;
						window['propsHistory'].push('/home#myScheduleAndBookmark');
					}
				else 
					{
						window['openOndemandFromBookmark'] = false;
						window['propsHistory'].push('/home');
					}							
			}
	}

    window.onChannelMessage = (message, senderId, isFromOnDemand) => {
        console.log('Channel Message - ', message);

        let remoteUser = senderId.includes("RM-");

        if (remoteUser === false && !isFromOnDemand) {
            let userExists = window.checkSessionUser(senderId);

            if (userExists === true) {       

                window.channelMsgHandler(message.text, senderId, currentUserData.userType);
            } else {
                if (window.pendingUsers.length > 0) {
                    let senderExists = false;

                    window.pendingUsers.forEach((user)=>{
                        if (user.senderId == senderId) {
                            senderExists = true;
                        }
                    });

                    if (senderExists === false) {
                        let userData = {"senderId": senderId, "message": message};
                        window.pendingUsers.push(userData);
                    }
                } else {
                    let userData = {"senderId": senderId, "message": message};
                    window.pendingUsers.push(userData);
                }
            }
        } else {
            window.channelMsgHandler(message.text, senderId, currentUserData.userType, true);
        }
    }

    function sendMessage(peerId, text)
    {
        console.log('send message - ', peerId, text);

        newclient.sendMessageToPeer({text}, peerId).then(sendResult => {

          if (sendResult.hasPeerReceived) {
              retryCounter = 0;
          } else {

              if (retryCounter <= 3) {
                  retryCounter++;

                  setTimeout(function(){
                      sendMessage(peerId, text);
                  }, 500);
              } else {
                  retryCounter = 0;
              }
          }
        }).catch(error => {
            console.log('peer error - ', error);
            retryCounter = 0;
        });
    }
    
	window['globalRTM'] = sendMessage;
	
    window.networkBandwidth = function () {
        if (currentUserData.userType == Const.USER_TYPE.HOST) {
            if (currentUserData.sessionData.CustomResolutionHigh != undefined) {
                localStorage.setItem("video-resolution", currentUserData.sessionData.CustomResolutionHigh);
				if ( window['setDefResolutionInstructor'] )
					{
						window['setDefResolutionInstructor'](currentUserData.sessionData.CustomResolutionHigh);
					}
            } else {
                localStorage.setItem("video-resolution", Const.HOST_RESOLUTION_TYPE.SD);
            }
        } else {
            let length = getTempUsers().length-1;

            if (length <= 3) {
                localStorage.setItem("video-resolution", Const.PARTICIPANT_RESOLUTION_TYPE.HD);
            } else {
                localStorage.setItem("video-resolution", Const.PARTICIPANT_RESOLUTION_TYPE.SD);
            }
        }
    }

    var checkMic = function(micId){ 
        let addObject = null;
        stream2 = AgoraRTC.createStream({
            streamID: Math.floor(Math.random()*1000000),
            video: false,
            audio: true,
            microphoneId: micId
        });
		    window['stream22'] = stream2;
          // The user has granted access to the camera and mic.
          stream2.on("accessAllowed", function() {
              localStorage.setItem('microphoneAccessAllowed', true);
		
              addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.DEVICE, "eventType": "microphone", "userId": currentUserData.id, "details": JSON.stringify({"status": "success"}), "timestamp": Util.getCurrentTimestamp()};
              sessionDataStore.addSessionData(addObject);
          });

          // The user has denied access to the camera and mic.
          stream2.on("accessDenied", function(err) {
              console.log("mic accessDenied - ", err);

              if (localStorage.getItem('microphoneAccessAllowed') === null) {
                  localStorage.setItem('microphoneAccessAllowed', false);
              }

              addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.DEVICE, "eventType": "mic", "userId": currentUserData.id, "details": JSON.stringify({"status": "error", "reason": err.type}), "timestamp": Util.getCurrentTimestamp()};
              sessionDataStore.addSessionData(addObject);
          });

        // Initialize the stream.
        stream2.init(function(){
            //
      			if( window['electron'] )
      				{
      					AgoraRTC.switchMic((localStream) => {
      						localStream.setAudioRecordingDevice(micId.toString());
      					});
      				}
            }, function (err) {

            if (localStorage.getItem('mediaAccessError') === null) {
                localStorage.setItem('mediaAccessError', err.msg);
            }

            console.log("getUserMedia failed in checkMic()======", err);

            addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.DEVICE, "eventType": "microphone", "userId": currentUserData.id, "details": JSON.stringify({"status": "fail", "msg": err.msg + ' | ' + err.info}), "timestamp": Util.getCurrentTimestamp()};
            sessionDataStore.addSessionData(addObject);
        });
    };

	function MakeQuerablePromise(promise) {
		if (promise.isFulfilled) return promise;

		var isPending = true;
		var isRejected = false;
		var isFulfilled = false;

		var result = promise.then(
			function(v) {
				isFulfilled = true;
				isPending = false;
				return v; 
			}, 
			function(e) {
				isRejected = true;
				isPending = false;
				throw e; 
			}
		);

		result.isFulfilled = function() { return isFulfilled; };
		result.isPending = function() { return isPending; };
		result.isRejected = function() { return isRejected; };
		return result;
	}

    var stream2 = null;
    var stream1 = [];
    var tempVideoStream = null;

    window.getDevices = () => {
	console.log('preStreamingController getDevices---1');
		
		let cameraDevicesArray = [];
		isCameraDetected = false;
		let addObject = null;
		addObject = {"sessionId": currentUserData.sessionData.id, "event": "status", "eventType": "getDevices", "userId": currentUserData.id, "details": JSON.stringify({"msg": "getDevices method is called"}), "timestamp": Util.getCurrentTimestamp()};
		sessionDataStore.addSessionData(addObject);
	console.log('preStreamingController getDevices---2');

		const tempAudioStream = AgoraRTC.createStream({ audio: true, video: false });
		tempVideoStream = AgoraRTC.createStream({ audio: false, video: true });
	console.log('preStreamingController getDevices---3');
		const audioPermissionOK = new Promise(resolve => {
			tempAudioStream.init(() => resolve(null), (e) => resolve(e));
		});
	console.log('preStreamingController getDevices---4');
		const videoPermissionOK = new Promise(resolve => {
			tempVideoStream.init(() => resolve(null), (e) => resolve(e));
		});
	console.log('preStreamingController getDevices---5');
	
		var audioPromise = MakeQuerablePromise(audioPermissionOK);
		var videoPromise = MakeQuerablePromise(videoPermissionOK);
	console.log('preStreamingController getDevices---6');
		
		if( !window['electron'] )
			{
				let duration = 20000;
				if ( currentUserData.default.cameraPermissionMessage )
					{
						duration = parseInt(currentUserData.default.cameraPermissionMessage)*1000;
					}
				setTimeout( function(){
					
					if ( audioPromise.isPending() || videoPromise.isPending() )
						{
							$('#retry_permission_devices').modal('show');
						}
				}, duration);
			}
	console.log('preStreamingController getDevices---7');
		
		Promise.all([audioPermissionOK, videoPermissionOK]).then(res => {
			if (res[0] !== null) {
				console.warn("create audio temp stream failed!", res[0]);
			}
			if (res[1] !== null) {
				console.warn("create video temp stream failed!", res[1]);
				if( res[1].msg == 'NotReadableError' ) { localStorage.setItem('cameraAccessAllowed', false); }
			}

			let defaultSel = 0;
			AgoraRTC.getDevices(function (devices) {

				localStorage.removeItem('mediaAccessError');

				addObject = {"sessionId": currentUserData.sessionData.id, "event": "status", "eventType": "getDevices", "userId": currentUserData.id, "details": JSON.stringify({"msg": "devices length", "length": devices.length}), "timestamp": Util.getCurrentTimestamp()};
				sessionDataStore.addSessionData(addObject);

				if ( !devices || devices.length == 0 && window['onDemand'] )
					{
						setTimeout(function(){
							window.showJoinButton();
						}, 2000)
					}
				
				let vdoMediaHtml = '';
				let adoMediaHtml = '';
				let speakerMediaHtml = '';
				let speak_id = null;

				console.log('devices====', devices);            

				let cameraId = null,
		
				microphoneId = null;
				main_mic_id = null;

				$('#video-media-content').html('');
				$('#cameraSelect').html('');
				$('#audio-media-content').html('');
				$('#speaker-media-content').html('');

				let device = '';
				let deviceId = '';
				let deviceArray = [];
				var d = [];
				var l = 0;
				let frontCamera = false;

				var vizualizerMain = '<svg preserveAspectRatio="none" id="visualizer" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"></svg>';
				
				var isMarketplaceChannel = JSON.parse(localStorage.getItem('userData')).isMarketplaceChannel;
				var  WASRequiredInWaitingLounge = parseInt(JSON.parse(localStorage.getItem('userData')).default.WASRequiredInWaitingLounge);
				var videoMain;
				if ( isMarketplaceChannel == 1 && WASRequiredInWaitingLounge == 1 )
					{
						videoMain = '<div class="turning_video_title">Camera</div><div class="for_cameras_cbx camera_main_holder" id="camera_cbx"></div><div class="for_cameras_main" id="video_camera"><div class="prestreaming_nocam d-none"><div class="muted_ps"></div></div><div id="local-media"><small class="pre-click-zoom d-none" data-toggle="tooltip" title="Zoom" onClick="zoomVideo()"><img src="images/icon-body-focus.png" /></small></div></div>';
					}
				else 
					{
						videoMain = '<div class="turning_video_title">Camera</div><div class="for_cameras_cbx camera_main_holder" id="camera_cbx"></div><div class="for_cameras_main" id="video_camera"><div class="prestreaming_nocam d-none"><div class="muted_ps"></div></div><div id="local-media"><div class="continue_allowed skiproomsetupsh d-none" onClick="zoomVideo(true)">SKIP</div><small class="pre-click-zoom d-none" data-toggle="tooltip" title="Zoom" onClick="zoomVideo()"><img src="images/icon-body-focus.png" /></small></div></div>';
					}
				$('#video-media-content').html(videoMain);
	console.log('preStreamingController getDevices---8');
				window['devicesLoaded'] = true;
				console.log(currentUserData.userType, 'imageCanvas');
				if ( currentUserData.userType == 2 )
					{
						var whiteboardCanvas = '<div id="canvasWrap" class="canvasHold centerCanvas d-none"><canvas class="canvasDraw" id="sessionCanvas" width="1280" height="720"></canvas><canvas class="canvasGrid canvasImage" id="imageCanvas" width="1280" height="720"></canvas><canvas class="canvasImage" id="bufferCanvas" width="640" height="360"></canvas><div id="workoutAreaButton" className="workoutButton d-none">T <br/> A <br/> P</div></div><span id="partToolTip" class="room_capturing_popup bg-grayy rounded d-none"><span class="separate_stats tool_tip_inner"><span class="tooltipSuccess d-none"><svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></span><svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 20 130 80" class="tooltipSvg d-none"><polyline id="v_shape" points="5 -10 50 60 80 60 125 -10" stroke="white" fill="transparent" stroke-width="20"/><defs><linearGradient id="progress"><stop id="stop1" offset="0" stop-color="rgb(32, 205, 243)"/><stop id="stop2" offset="0" stop-color="white"/></linearGradient></defs></svg><div class="tooltipImage"></div><div id="upNextText" class="up_next d-none"></div><div class="tooltipText rounded"></div><div id="innerPartText" class="part_inner"></div><div id="walkToolImage" class="walk_tool_hold d-none"><div class="walk_tool_image"></div><div class="walk_tool_text"></div></div><div class="tooltipNumber d-none"></div></span><span id="progressBarRoom" class="separate_stats d-none"></span></span><span id="heightToolTip" class="screen_popup room_capturing_popup height_tip d-none"><div id="heightProgressBar"><div class="tooltipText rounded progress_bar_percent"><span id="progressHeightNum">0</span><span id="percentProgress">%</span></div><div id="heightProgress"></div></div><div class="heightTipText bg-grayy rounded stand_still_box">Stand still <span class="separate_stats">Capturing height</span></div></span>';
						$('#local-media').append(whiteboardCanvas);
					}
				else
					{
						var whiteboardCanvas = '<div id="canvasWrap" class="canvasHold centerCanvas d-none"><canvas class="canvasDraw" id="sessionCanvas" width="1280" height="720"></canvas><canvas class="canvasGrid canvasImage" style="left: 0 !important" id="imageCanvas" width="1280" height="720"></canvas><canvas class="canvasImage" id="bufferCanvas" width="640" height="360"></canvas><div id="workoutAreaButton" className="workoutButton d-none">T <br/> A <br/> P</div></div><span id="partToolTip" class="room_capturing_popup bg-grayy rounded d-none"><span class="separate_stats tool_tip_inner"><span class="tooltipSuccess d-none"><svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></span><svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 20 130 80" class="tooltipSvg d-none"><polyline id="v_shape" points="5 -10 50 60 80 60 125 -10" stroke="white" fill="transparent" stroke-width="20"/><defs><linearGradient id="progress"><stop id="stop1" offset="0" stop-color="rgb(32, 205, 243)"/><stop id="stop2" offset="0" stop-color="white"/></linearGradient></defs></svg><div class="tooltipImage"></div><div id="upNextText" class="up_next d-none"></div><div class="tooltipText rounded"></div><div id="innerPartText" class="part_inner"></div><div id="walkToolImage" class="walk_tool_hold d-none"><div class="walk_tool_image"></div><div class="walk_tool_text"></div></div><div class="tooltipNumber d-none"></div></span><span id="progressBarRoom" class="separate_stats d-none"></span></span><span id="heightToolTip" class="screen_popup room_capturing_popup height_tip d-none"><div id="heightProgressBar"><div class="tooltipText rounded progress_bar_percent"><span id="progressHeightNum">0</span><span id="percentProgress">%</span></div><div id="heightProgress"></div></div><div class="heightTipText bg-grayy rounded stand_still_box">Stand still <span class="separate_stats">Capturing height</span></div></span>';
						$('#local-media').append(whiteboardCanvas);
					}	

				var audioMainSpeaker = '<div class="for_all_test_sp"><div class="main_title_speakers pb20">Speaker</div><div class="all_width_mic"><div class="left_speakers"><select class="main_select" id="select_speakers"></select></div><div class="right_speakers"><div class="test_title cursor" id="test_speakers"><span class="relative_test">TEST<div class="absolute_spc"></div></span></div><div class="test_title cursor gray_clr" id="test_speakers_playing" style="display: none"><span class="relative_test">Playing...<div class="absolute_spc"></div></span></div></div></div></div>';
				$('#speaker-media-content').append(audioMainSpeaker);

				var audioMain = '<div class="for_all_test_sp"><div class="main_title_speakers">Mic</div><div class="all_width_mic"><div class="left_speakers"><select class="main_select" id="select_microphone"></select></div><div class="right_speakers"><div class="test_title cursor" id="test_mic"><span class="relative_test">TEST<div class="absolute_mic"></div></span></div><div class="test_title cursor" style="display: none" id="test_mic_pause"><div class="for_visualizer">'+vizualizerMain+'<div class="absolute_mic"></div></div></div><div class="test_title cursor gray_clr" style="display: none" id="test_mic_rec"><span class="relative_test">Speak into Mic Now...<div class="absolute_mic"></div></div><div class="test_title cursor gray_clr" style="display: none" id="test_mic_play"><div class="for_visualizer">'+vizualizerMain+'<div class="absolute_mic"></div></div></div><div class="test_title cursor gray_clr top_margin_title" style="display: none" id="test_mic_rechear"><span class="gray_clr">Did you hear yourself?</span><button class="ok-btn padbtt heardyourselfyes">Yes</button><button class="ok-btn padbtt heardyourselfno">No</button></div></div></div>';

				$('#audio-media-content').append(audioMain);
	console.log('preStreamingController getDevices---9');

				let mediaIds1 = localStorage.getItem(hostlanguage.mediaSetting);
				let mediaIds = JSON.parse(mediaIds1);
				let deviceVideoIdsArray = [];
				let deviceAudioIdsArray = [];
				let deviceSpeakerIdsArray = [];
				if (devices && devices.length > 0)
					{
						for (var i = 0; i !== devices.length; ++i) 
							{
								if ( devices[i].kind && devices[i].kind === 'videoinput' ) 
									{
										deviceVideoIdsArray.push(devices[i].deviceId);
									}
								else if ( devices[i].kind && devices[i].kind === 'audioinput' ) 
									{
										deviceAudioIdsArray.push(devices[i].deviceId);
									}
								else if ( devices[i].kind && devices[i].kind === 'speaker' ) 
									{
										deviceSpeakerIdsArray.push(devices[i].deviceId);
									}
							}
					}
	console.log('preStreamingController getDevices---10');

				for (var i = 0; i !== devices.length; ++i) 
					{
						console.log('devices*******************');
						console.log(devices);
						if(!devices[i] || devices[i] == undefined) continue;

						device = devices[i];

						deviceId = device.deviceId;

						if(deviceArray.includes(deviceId+'-'+device.kind)) continue;

						let defaultSetting = '';

						deviceArray.push(deviceId+'-'+device.kind);

						if (device.kind === 'speaker') 
							{
								if(speak_id == null) 
									{
										defaultSetting = 'checked';
										speak_id = deviceId;
									}

								if ( mediaIds && mediaIds.speaker && deviceSpeakerIdsArray.indexOf(mediaIds.speaker) > -1 )
									{
										speak_id = null;
										defaultSetting = '';

										if ( mediaIds.speaker == deviceId )
											{
												speak_id = mediaIds.speaker;
												defaultSetting = 'checked';
											}
									}

								var selectOptionsSpc = '<option id="lbl-'+l+'" value="'+deviceId+'" '+ defaultSetting +'>'+ device.label +'</option>';
								$('#select_speakers').append(selectOptionsSpc);

								if( window['electron'] ) { $('.width_speaker').removeClass('d-none'); }
								l++;
							} 
						else if (device.kind === 'audioinput') 
							{
								isMicrophoneDetected = true;

								if(microphoneId == null) 
									{
										microphoneId = deviceId;
										main_mic_id = deviceId;
										window['main_mic_id_gue'] = deviceId;
										defaultSetting = 'checked';
									
									}

								if ( mediaIds && mediaIds.microphone && deviceAudioIdsArray.indexOf(mediaIds.microphone) > -1 )
									{
										microphoneId = null;
										main_mic_id = null;
										window['main_mic_id_gue'] = null;
										defaultSetting = '';
										if ( mediaIds.microphone == deviceId )
											{
												microphoneId = mediaIds.microphone;
												main_mic_id = mediaIds.microphone;
												window['main_mic_id_gue'] = mediaIds.microphone;
												defaultSetting = 'checked';
											}
									}
							
								var selectOptionsMic = '<option id="lbl-'+l+'" value="'+deviceId+'" '+ defaultSetting +'>'+ device.label +'</option>';
								$('#select_microphone').append(selectOptionsMic);
								if(defaultSetting == 'checked')
									{
										checkMic(deviceId);
									}
							} 
						else if (device.kind === 'videoinput') 
							{
								
								isCameraDetected = true;

								let label = device.label.toLowerCase();

								if ( window['ipad'] && label.includes("front") === false )
									{
										continue;
									}

								if(cameraId == null) 
									{
										cameraId = deviceId;
										defaultSetting = 'checked';
										defaultSel = l;

										if (label.includes("front")) 
											{
												frontCamera = true;
											}
									} 
								else if (label.includes("front") && frontCamera === false) 
									{
										defaultSetting = 'checked';
										defaultSel = l;
										frontCamera = true;
									}	
								if ( mediaIds && mediaIds.camera && deviceVideoIdsArray.indexOf(mediaIds.camera) > -1 )
									{
										defaultSetting = '';

										if ( mediaIds.camera == deviceId )
											{
												defaultSetting = 'checked';
												defaultSel = deviceVideoIdsArray.indexOf(mediaIds.camera);

												cameraId = deviceId;
												
												if ( !window['cameraValue'] )
													{
														window['cameraValue'] = deviceId;
														window.autoSetCamera(l);
													}
											
												if ( window.cameraSelectValue )
													{
														window.cameraSelectValue(l);
													}
											}
									}
								let deviceValue = deviceId;
								let deviceObject = {'label': device.label, 'value': deviceValue };	
								vdoMediaHtml = '<div class="check-camera inline_cbx"><input type="radio" class="form-radio" name="video-type" id="lbl-'+l+'" data-keyid="'+l+'" value="'+deviceId+'" '+ defaultSetting +'><label for="lbl-'+l+'"> '+ device.label +'</label></div>';
								//$('#camera_cbx').append(vdoMediaHtml);
								$("#cameraSelect").append('<option  data-keyid='+l+' value='+l+'>'+device.label+'</option>');
								
								
								cameraDevicesArray.push(deviceObject);
								
								d[l] = deviceId;
									stream1[l] = AgoraRTC.createStream({
									streamID: Math.floor(Math.random()*1000000),
									video: true,
									audio: false,
									cameraId: d[l]
								});
						
								stream1[l].on("accessAllowed", function() {
									localStorage.setItem('cameraAccessAllowed', true);
									console.log("video accessAllowed---------");
									
									if ( window['onDemand'] )
										{
											setTimeout(function(){
												window.showJoinButton();
											}, 2000);
										}
									
									
									if ( !window['cameraValue'] )
										{
											window['cameraValue'] = deviceId;
											if ( window.cameraSelectValue )
												{
													window.cameraSelectValue(l);
												}
											window.autoSetCamera(l);	
											console.log("autoSetCamera-");
										}
									
									addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.DEVICE, "eventType": "camera", "userId": currentUserData.id, "details": JSON.stringify({"status": "success"}), "timestamp": Util.getCurrentTimestamp()};
									sessionDataStore.addSessionData(addObject);
								});

								stream1[l].on("accessDenied", function(err) {
									console.log("video accessDenied", err);

									if (localStorage.getItem('cameraAccessAllowed') === null) {
									localStorage.setItem('cameraAccessAllowed', false);
									}

									addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.DEVICE, "eventType": "camera", "userId": currentUserData.id, "details": JSON.stringify({"status": "error", "reason": err.type}), "timestamp": Util.getCurrentTimestamp()};
									sessionDataStore.addSessionData(addObject);
								});

								l++;
								
							}
					}
	console.log('preStreamingController getDevices---11');

				if ( mediaIds && mediaIds.microphone && deviceAudioIdsArray.indexOf(mediaIds.microphone) > -1 )
					{
						$('#select_microphone').val(mediaIds.microphone);
					}

				if ( mediaIds && mediaIds.speaker && deviceSpeakerIdsArray.indexOf(mediaIds.speaker) > -1 )
					{
						$('#select_speakers').val(mediaIds.speaker);
					}

				
				if ( !isCameraDetected ) 
					{ 
						console.log('cameraDetectionError');
						cameraDetectionError(); 
					}
				else
					{
						window['dontHaveAnyCam'](false);
					}
	console.log('preStreamingController getDevices---12');
				if ( !isMicrophoneDetected ) 
					{ 
						window['dontHaveAnyMic'](true);
						if ( isCameraDetected )
							{
								micDetectionError(); 
							}
					}
				else
					{
						window['dontHaveAnyMic'](false);
					}
	console.log('preStreamingController getDevices---13');

				if( stream1.length > 0 )
					{
						if ( window['electron'] )
							{
								if ( stream1 && stream1[defaultSel] )
									{
										console.log('-----set video profile here---');
										//stream1[defaultSel].setVideoProfile('360p_11');
										stream1[defaultSel].init(function(){
										window.autoSetCamera(defaultSel);
										console.log('stream1111');
										console.log(defaultSel);
										console.log(stream1[defaultSel]);
										stream1[defaultSel].play('local-media');
										//stream1[defaultSel].muteAudio();
											if ( window['electron'] && ( currentUserData.userType == 2 || currentUserData.isMarketplaceChannel == 1 ) ) { window['changeCameraRes'](window['currentResolution']); }
											if ( window['electron'] && currentUserData.userType == 1 && currentUserData.isMarketplaceChannel == 0 ) { window['changeCameraRes']('sd'); }
											}, function (err) {

											localStorage.setItem('mediaAccessError', err.msg);

											if (stream1.length === 1)
												{
													window.mediaAccessAllowed = false;
													if ( !$('#mic-detection-alert').modal()[0] )
														{
															console.log('shoooow1');
															showMicDetectionAler();
														}
												}

											console.log("getUserMedia failed in getdevices()======", err);

											addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.DEVICE, "eventType": "camera", "userId": currentUserData.id, "details": JSON.stringify({"status": "fail", "msg": err.msg + ' | ' + err.info}), "timestamp": Util.getCurrentTimestamp()};
											sessionDataStore.addSessionData(addObject);
										});
									}
							}
						else
							{
								let i = 0;
								for(let l in stream1)
									{
										if ( i > 0) 
											{
												continue;
											} 
										else 
											{											 
												let key = 0;
												if ( mediaIds )
													{
														key = defaultSel;
													}

												if ( window['currentlyOnPrestreaming'] )
													{
														// Initialize the stream.
														stream1[key].init(function(){
														window.autoSetCamera(i);
														console.log('stream222');
														stream1[key].play('local-media');
															}, function (err) {
																if (stream1.length === 1)
																	{
																		window.mediaAccessAllowed = false;

																		switch ( err.msg ) {
																			case 'NotAllowedError':
																			$('#media-access-alert-heading').text('Camera Required to Attend Class');
																			$('#media-access-alert-text').text('Camera access has been denied. Your instructor requires camera access to attend the class.');
																			break;
																			case 'NotReadableError': 
																			$('.try-again').addClass('d-none');
																			$('#media-access-alert-text').text('Virdio is unable to access your camera or microphone even though access was granted. Please check if it’s being used by another app or restart your device.');
																			break;
																		}
																		if ( !$('#mic-detection-alert').modal()[0] )
																			{
																				console.log('shoooow2');
																				showMicDetectionAler();
																			}
																	}

																localStorage.setItem('mediaAccessError', err.msg);

																console.log("getUserMedia failed in getdevices()======", err);

																addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.DEVICE, "eventType": "camera", "userId": currentUserData.id, "details": JSON.stringify({"status": "fail", "msg": err.msg + ' | ' + err.info}), "timestamp": Util.getCurrentTimestamp()};
																sessionDataStore.addSessionData(addObject);
															});
													}
												
													
											}

										i++;
									}
							}
					}
	console.log('preStreamingController getDevices---14');

				let ref = setInterval(function(){
					if (localStorage.getItem("cameraAccessAllowed") !== null && localStorage.getItem("microphoneAccessAllowed") !== null) 
						{
							clearInterval(ref);
							if (localStorage.getItem('cameraAccessAllowed') == "true" && localStorage.getItem('microphoneAccessAllowed') == "true") 
								{
									window.mediaAccessAllowed = true;
									$('#media-access-alert').modal('hide');
								} 
							else 
								{
									window.mediaAccessAllowed = false;

									switch ( localStorage.getItem('mediaAccessError') ) 
										{
											case 'NotAllowedError':
											if ( localStorage.getItem("cameraAccessAllowed") == "false" ) 
												{ 
													$('#media-access-alert-heading').text('Camera Required to Attend Class');
													$('#media-access-alert-text').text('Camera access has been denied. Your instructor requires camera access to attend the class.');
													if (currentUserData.userType == 2 && currentUserData.sessionData.isCameraRequired == 0) { $('#joinWithoutCamera').removeClass('d-none'); }
												}
											else if ( localStorage.getItem("microphoneAccessAllowed") == "false" ) 
											{
												$('#media-access-alert-heading').text('Microphone Required to Attend Class');
												$('#media-access-alert-text').text('Microphone access has been denied. Your instructor requires microphone access to attend the class.');
												if (currentUserData.userType == 2 && currentUserData.sessionData.isCameraRequired == 0) { $('#joinWithoutCamera').addClass('d-none'); }
											}

											break;
											case 'NotReadableError': 
											$('.try-again').addClass('d-none');
											$('#media-access-alert-text').text('Virdio is unable to access your camera or microphone even though access was granted. Please check if it’s being used by another app or restart your device.');
											break;
										}

									if ( !$('#mic-detection-alert').modal()[0] )
										{
											console.log('shoooow3');
											showMicDetectionAler();
										}
								}
						}
				}, 1000);
	console.log('preStreamingController getDevices---15');

				if( !window['electron'] ) { tempAudioStream.close(); }
			});
		});
    
		newCameraArray = cameraDevicesArray;
		window['newCameraArrayList'] = cameraDevicesArray;
	console.log('preStreamingController getDevices---16');
	}
	
	$(document).off('click', '.startTestingSpeakersPre');
	$(document).on('click', '.startTestingSpeakersPre', function(){
	   if( $(".startTestingSpeakersPre:visible").html() === "Speak into Mic Now..." || $(".startTestingSpeakersPre:visible").html() === "Playing..." ) { return false; } 
	 
		if( window['electron'] )
			{
				AgoraRTC.startEchoTestWithInterval(5);
				$(".startTestingSpeakersPre:visible").html("Speak into Mic Now...");
					
				$(".speakersTestingResults:visible").html("Recording started, after 5 seconds will be played back.");
				var i = 5;
				var my_int = setInterval(() => {
					i--;
					if( i === 0 ) 
						{
							$(".startTestingSpeakersPre:visible").html("Playing...");
							$(".speakersTestingResults:visible").html("");
							clearInterval(my_int); 
							
							setTimeout(() => {
								AgoraRTC.stopEchoTest();
								$(".startTestingSpeakersPre:visible").html("Test Microphone and Speaker");
							}, 5000);
							
							return;
						}
					$(".speakersTestingResults:visible").html("Recording started, after " +i + " seconds will be played back.");
					
				}, 1000);
			}
	});
	
	$(document).off('click', '.startTestingMicrophonePre');
	$(document).on('click', '.startTestingMicrophonePre', function(){
	   if( $(".startTestingMicrophonePre:visible").next().html() === "Speak into Mic Now..." || $(".startTestingMicrophonePre:visible").next().html() === "Playing..." ) { return false; } 
	   
	   if(window['sessionCountdownInterval'])
		   {
			   clearInterval(window['sessionCountdownInterval']);
			   $('#change-setting-timer').html("");
		   }	

	   if( window['electron'] )
			{
				AgoraRTC.startEchoTestWithInterval(5);
				$(".startTestingMicrophonePre:visible").next().html("Speak into Mic Now...");
					
				var i = 5;
				var my_int = setInterval(() => {
					i--;
					if( i === 0 ) 
						{
							$(".startTestingMicrophonePre:visible").next().html("Playing...");
							clearInterval(my_int); 
							
							setTimeout(() => {
								AgoraRTC.stopEchoTest();
								$(".startTestingMicrophonePre:visible").next().html("");
							}, 5000);
							
							return;
						}
				}, 1000);
			}
		else if( main_mic_id )
			{
				navigator.mediaDevices.getUserMedia({ audio: { deviceId: { exact: main_mic_id.toString() } } }).then((stream) =>{
					console.log(stream);
					var chunks = [];
						var mediaRecorder = new MediaRecorder(stream);
						
						mediaRecorder.ondataavailable = function(e) {
						  chunks.push(e.data);
						}
						
						mediaRecorder.onerror = function(){
							$(".startTestingMicrophonePre:visible").next().html("");
							if( stream.getAudioTracks && stream.getAudioTracks() && stream.getAudioTracks()[0] ) { stream.getAudioTracks()[0].stop(); }
						}
						
						mediaRecorder.onstop = function(e) {
							var audio = document.createElement('audio');
							if( safari )
							{
								var blob = new Blob(chunks, {'type' : 'audio/mpeg'});
								chunks = [];
								var audioURL = URL.createObjectURL(blob);
								audio.src = audioURL;
								audio.preload = null;
								$(".startTestingMicrophonePre:visible").next().html("<div class='safary_play_btn'>Play</div>");
								$('.safary_play_btn').on('click', function(){
									audio.play();
									$(".startTestingMicrophonePre:visible").next().html("Playing...");
								});
							}
							else {
								var blob = new Blob(chunks, {'type' : 'audio/ogg; codecs=opus'});
								chunks = [];
								var audioURL = URL.createObjectURL(blob);
								audio.src = audioURL;
								
								audio.play();
								$(".startTestingMicrophonePre:visible").next().html("Playing...");
							}
							audio.onended = function(){
								if( stream.getAudioTracks && stream.getAudioTracks() && stream.getAudioTracks()[0] ) { stream.getAudioTracks()[0].stop(); }
								$(".startTestingMicrophonePre:visible").next().html("");
							};
						}
						
						mediaRecorder.start();
						$(".startTestingMicrophonePre:visible").next().html("Speak into Mic Now...");
						
						var i = 5;
						var my_int = setInterval(() => {
							i--;
							if( i === 0 ) 
								{
									mediaRecorder.stop();
									clearInterval(my_int); 
									return;
								}
						}, 1000);
				});
			}
   });
	
	$(document).off('change', '#select_microphone');
	$(document).on('change', '#select_microphone', function(){
		  main_mic_id = $(this).val();
		  window['main_mic_id_gue'] = $(this).val();
		  
  		let mediaIds1 = localStorage.getItem(hostlanguage.mediaSetting);
  		let mediaIds = JSON.parse(mediaIds1);
  		if ( mediaIds )
  			{
  				mediaIds.microphone = $(this).val();
  				localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaIds));
  			}
  		else
  			{
  				mediaIds = {};
  				mediaIds.microphone = $(this).val();
  				localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaIds));
  			}
		  
		  if( window['electron'] )
			{
				AgoraRTC.switchMic((localStream) => {
					localStream.setAudioRecordingDevice(main_mic_id.toString());
				});
			}
  });
	  
	
	var mainSpeakerTestStream;
	var client;
	var isPlayedSpeaker = 0;
	var stopTimeOut;
	$(document).off('click', '#test_speakers');
	$(document).on('click', '#test_speakers', function(){
		if ( isPlayedAudio === 1 ) { return false; } 
		clearTimeout(stopTimeOut);
		var channel_key = currentUserData.sessionData.streamDummyToken != undefined ? currentUserData.sessionData.streamDummyToken : null;
		let mediaIds1 = localStorage.getItem(hostlanguage.mediaSetting);
        let mediaIds = JSON.parse(mediaIds1);
		if ( mediaIds && mediaIds.speaker )
			{
				AgoraRTC.switchSpeaker(mediaIds.speaker);
			}
		
		if ( !window['globalAgora']['inChannel'] )
				{
					var channelName = 9999999999 + '' + currentUserData.sessionData.channelId + '' + currentUserData.id;
					window['globalAgora'].setClientRole(1); // Host role
						
					window['globalAgora'].setEncryptionMode(process.env.REACT_APP_ENC_MODE);
					window['globalAgora'].setEncryptionSecret(process.env.REACT_APP_ENC_SECRET);

					// create and join channel
					
					window['globalAgora'].join(channel_key, channelName.toString(), currentUserData.id, function(uid) {
						if ( !mainSpeakerTestStream )
							{
								mainSpeakerTestStream = AgoraRTC.createStream({streamID: uid, audio: true, cameraId: 0, microphoneId: main_mic_id, video: false, screen: false });
							}
							
						window['globalAgora'].agora.muteLocalAudioStream(true);
						window['globalAgora'].agora.muteAllRemoteAudioStreams(true);
						
						var testPath = window['recordingPath'].replace(/\\/g, '/')+'/test_speaker.mp3';
						
						if ( window['fsFile'].existsSync(window['applicationPath']+'/build/audio/test_speaker.mp3') && !window['fsFile'].existsSync(testPath)  )
							{
								window['fsFile'].copyFileSync(window['applicationPath']+'/build/audio/test_speaker.mp3', testPath);
							}

						var streamUrl = testPath;
						mainSpeakerTestStream.startAudioMixing({filePath: streamUrl, playTime: 0}, function(error) {
							if (error) {
								// Error handling
								return;
							}
						});
						
						isPlayedSpeaker = 1;
						$('#test_speakers').hide();
						$('#test_speakers_playing').show();
						
						stopTimeOut = setTimeout(function(){ $('#test_speakers_playing').click(); }, 5000);
					});
				}
			else
				{
						if ( !mainSpeakerTestStream )
							{
								mainSpeakerTestStream = AgoraRTC.createStream({streamID: new Date().getTime(), audio: true, cameraId: 0, microphoneId: main_mic_id, video: false, screen: false });
							}
						
						var testPath = window['recordingPath'].replace(/\\/g, '/')+'/test_speaker.mp3';
						
						if ( window['fsFile'].existsSync(window['applicationPath']+'/build/audio/test_speaker.mp3') && !window['fsFile'].existsSync(testPath)  )
							{
								window['fsFile'].copyFileSync(window['applicationPath']+'/build/audio/test_speaker.mp3', testPath);
							}

						var streamUrl = testPath;
						
						mainSpeakerTestStream.startAudioMixing({filePath: streamUrl, playTime: 0}, function(error) {
							if (error) {
								// Error handling
								return;
							}
						});
						
						isPlayedSpeaker = 1;
						$('#test_speakers').hide();
						$('#test_speakers_playing').show();
						
						stopTimeOut = setTimeout(function(){ $('#test_speakers_playing').click(); }, 5000);
				}
	});
	$(document).off('click', '#test_speakers_playing');
	$(document).on('click', '#test_speakers_playing', function(){
		mainSpeakerTestStream.stopAudioMixing();
		isPlayedSpeaker = 0;
		$('#test_speakers_playing').hide();
		$('#test_speakers').show();
	});
	

	var AudioContext = window.AudioContext || window.webkitAudioContext;
	var isPlayedAudio = 0;
	var audioTest;
	$(document).off('click', '#test_mic, #test_mic_pause, #test_mic_rec, #test_mic_play');
	$(document).on('click', '#test_mic, #test_mic_pause, #test_mic_rec, #test_mic_play', function(){
			if ( isPlayedSpeaker === 1 ) { return false; } 
			
			if ( !window['electron'] )
				{
					if ( !audioTest ) { audioTest = document.createElement('audio'); }
					if ( isPlayedAudio === 0 )
						{
							if ( main_mic_id == 'null' || !main_mic_id || main_mic_id == null ) { main_mic_id = $('#select_microphone').val(); }
							
							//play test microphone
							navigator.mediaDevices.getUserMedia({ audio: { deviceId: { exact: main_mic_id.toString() } } }).then((stream) =>{
								if ("srcObject" in audioTest) { audioTest.srcObject = stream; } 
								else { audioTest.src = window.URL .createObjectURL(stream); } 
								
								audioTest.onloadedmetadata = function (ev) { audioTest.play(); };
								
								var audioContent = new AudioContext();
								var audioStream = audioContent.createMediaStreamSource(stream);
								var analyser = audioContent.createAnalyser();
								audioStream.connect(analyser);
								analyser.fftSize = 1024;

								var frequencyArray = new Uint8Array(analyser.frequencyBinCount);
								
								var visualizer = $("#test_mic_pause #visualizer")[0];
								visualizer.setAttribute("viewBox", "0 0 250 90");

								var path;
								for (var i = 0; i < 10; i++) {
								  path = document.createElementNS("http://www.w3.org/2000/svg", "path");
								  path.setAttribute("stroke-width", "10");
								  path.setAttribute("stroke", "white");
								  path.setAttribute("stroke-linecap", "round");
								  path.setAttribute("stroke-linejoin", "round");
								  visualizer.appendChild(path);
								}
								
								var paths = $("#test_mic_pause path");
								var doDraw = function() {
								  requestAnimationFrame(doDraw);
								  analyser.getByteFrequencyData(frequencyArray);
								  var adjustedLength;
								  for (var i = 1; i < 9; i++) {
									  
									adjustedLength = Math.floor((Math.floor(frequencyArray[i*20]) - Math.floor(frequencyArray[i*20]) % 5)/5);
									if ( adjustedLength == 0 ) { adjustedLength = 1; } 
									
									paths[i].setAttribute("d", "M " + (i*25) + ",45 l 0,-" + adjustedLength + " l 0," + (adjustedLength*2));
								  }
								};
								doDraw();
								
								
							});  
							
							isPlayedAudio = 1;
							$('#test_mic').hide();
							$('#test_mic_pause').show();
						}
					else
						{
							//stop test microphone
							audioTest.pause();  
							isPlayedAudio = 0;
							$('#test_mic_pause').hide();
							$('#test_mic').show();
						}
				}
			else
				{
					if ( isPlayedAudio === 0 )
						{
							isPlayedAudio = 1;
							
							var channel_key = currentUserData.sessionData.streamDummyToken != undefined ? currentUserData.sessionData.streamDummyToken : null;
							if ( !window['globalAgora']['inChannel'] )
								{
									var channelName = 9999999999 + '' + currentUserData.sessionData.channelId + '' + currentUserData.id;

									window['globalAgora'].setClientRole(1); // Host role
										
									window['globalAgora'].setEncryptionMode(process.env.REACT_APP_ENC_MODE);
									window['globalAgora'].setEncryptionSecret(process.env.REACT_APP_ENC_SECRET);
									
									// create and join channel
									window['globalAgora'].join(channel_key, channelName.toString(), currentUserData.id, function(uid) {
											if ( !mainSpeakerTestStream )
												{
													mainSpeakerTestStream = AgoraRTC.createStream({streamID: uid, audio: true, cameraId: 0, microphoneId: main_mic_id, video: false, screen: false });
												}
											var recordingfile = 'testRecording_'+(new Date().getTime())+'.aac';
											var recPath = (osname === "Mac OS" ? '/tmp/' : './');
											if ( window['recordingPath'] ) { recPath = window['recordingPath'].replace(/\\/g, '/')+'/'; }
											var srec = window['globalAgora'].agora.startAudioRecording(recPath+recordingfile, 32000, 2);
											$('#test_mic').hide();
											$('#test_mic_rec').show();
											
												
											console.log('mainSpeakerTestStream2---', mainSpeakerTestStream);
												
											if ( srec == 0 )
												{
													setTimeout(() => {
														window['globalAgora'].agora.stopAudioRecording();
														
														setTimeout(() => {
															$('#test_mic_rec').hide();
															$('#test_mic_play').show();
															
															audioTest = document.createElement('audio');
															var audioTest2 = document.createElement('audio');
															audioTest.src = recPath+recordingfile;
															audioTest2.src = recPath+recordingfile;
															
															window['globalAgora'].agora.muteLocalAudioStream(true);
															window['globalAgora'].agora.muteAllRemoteAudioStreams(true);
															
															mainSpeakerTestStream.startAudioMixing({filePath: recPath+recordingfile, playTime: 0}, function(error) {
																if (error) {
																	// Error handling
																	return;
																}
															});
															
															//audioTest2.onloadedmetadata = function (ev) { audioTest2.play(); }
															audioTest.onloadedmetadata = function (ev)
															{
																audioTest.play();
																
																var audioContent = new AudioContext();
																var audioStream = audioContent.createMediaElementSource(audioTest);
																var analyser = audioContent.createAnalyser();
																audioStream.connect(analyser);
																analyser.fftSize = 1024;

																var frequencyArray = new Uint8Array(analyser.frequencyBinCount);
																
																var visualizer = $("#test_mic_play #visualizer")[0];
																visualizer.setAttribute("viewBox", "0 0 250 90");

																var path;
																for (var i = 0; i < 10; i++) {
																  path = document.createElementNS("http://www.w3.org/2000/svg", "path");
																  path.setAttribute("stroke-width", "10");
																  path.setAttribute("stroke", "white");
																  path.setAttribute("stroke-linecap", "round");
																  path.setAttribute("stroke-linejoin", "round");
																  visualizer.appendChild(path);
																}
																
																var paths = $("#test_mic_play path");
																var doDraw = function() {
																  if ( isPlayedAudio == 0 ) { return false; }
																
																  requestAnimationFrame(doDraw);
																  analyser.getByteFrequencyData(frequencyArray);
																  var adjustedLength;
																  for (var i = 1; i < 9; i++) {
																	  
																	adjustedLength = Math.floor((Math.floor(frequencyArray[i*20]) - Math.floor(frequencyArray[i*20]) % 5)/5);
																	if ( adjustedLength == 0 ) { adjustedLength = 1; }
																	
																	paths[i].setAttribute("d", "M " + (i*25) + ",45 l 0,-" + adjustedLength + " l 0," + (adjustedLength*2));
																  }
																};
																doDraw();
															}; 
																setTimeout(() => {
																	audioTest.pause();
																	audioTest = null;
																	$('#test_mic_play').hide();
																	//$('#test_mic').show();
																	$('#test_mic_rechear').show();
																	isPlayedAudio = 0;
																	
																	
																	
																	if ( window['fsFile'] ) { try { window['fsFile'].unlink(recPath+recordingfile); } catch (err) { } }
																	
																	mainSpeakerTestStream.stopAudioMixing();
																	
																}, 5000);
															}, 1000);
													}, 5000);	
												}
											else
												{
													$('#test_mic_rec').hide();
													$('#test_mic').show();
													$('#microphone_electron_error').modal('show');
												}
									});
											
								}
							else
								{
									var recordingfile = 'testRecording_'+(new Date().getTime())+'.aac';
									var recPath = (osname === "Mac OS" ? '/tmp/' : './');
									if ( window['recordingPath'] ) { recPath = window['recordingPath'].replace(/\\/g, '/')+'/'; }
									var srec = window['globalAgora'].agora.startAudioRecording(recPath+recordingfile, 32000, 2);
									console.log('srec1---', srec);
									$('#test_mic').hide();
									$('#test_mic_rec').show();
									if ( !mainSpeakerTestStream )
										{
											mainSpeakerTestStream = AgoraRTC.createStream({streamID: new Date().getTime(), audio: true, cameraId: 0, microphoneId: main_mic_id, video: false, screen: false });
										}
									if ( srec == 0 )
										{
											setTimeout(() => {
												window['globalAgora'].agora.stopAudioRecording();
												
												setTimeout(() => {
													$('#test_mic_rec').hide();
													$('#test_mic_play').show();
													
													audioTest = document.createElement('audio');
													var audioTest2 = document.createElement('audio');
													audioTest.src = recPath+recordingfile;
													audioTest2.src = recPath+recordingfile;
													
													//audioTest2.onloadedmetadata = function (ev) { audioTest2.play(); }
													window['globalAgora'].agora.muteLocalAudioStream(true);
													window['globalAgora'].agora.muteAllRemoteAudioStreams(true);
													
													mainSpeakerTestStream.startAudioMixing({filePath: recPath+recordingfile, playTime: 0}, function(error) {
														if (error) {
															// Error handling
															return;
														}
													});
													audioTest.onloadedmetadata = function (ev)
														{
																audioTest.play();
																
																var audioContent = new AudioContext();
																
																var audioStream = audioContent.createMediaElementSource(audioTest);
																var analyser = audioContent.createAnalyser();
																audioStream.connect(analyser);
																analyser.fftSize = 1024;

																var frequencyArray = new Uint8Array(analyser.frequencyBinCount);
																
																var visualizer = $("#test_mic_play #visualizer")[0];
																visualizer.setAttribute("viewBox", "0 0 250 90");

																var path;
																for (var i = 0; i < 10; i++) {
																  path = document.createElementNS("http://www.w3.org/2000/svg", "path");
																  path.setAttribute("stroke-width", "10");
																  path.setAttribute("stroke", "white");
																  path.setAttribute("stroke-linecap", "round");
																  path.setAttribute("stroke-linejoin", "round");
																  visualizer.appendChild(path);
																}
																
																var paths = $("#test_mic_play path");
																var doDraw = function() {
																  if ( isPlayedAudio == 0 ) { return false; }
																
																  requestAnimationFrame(doDraw);
																  analyser.getByteFrequencyData(frequencyArray);
																  var adjustedLength;
																  for (var i = 1; i < 9; i++) {
																	  
																	adjustedLength = Math.floor((Math.floor(frequencyArray[i*20]) - Math.floor(frequencyArray[i*20]) % 5)/5);
																	if ( adjustedLength == 0 ) { adjustedLength = 1; }
																	
																	paths[i].setAttribute("d", "M " + (i*25) + ",45 l 0,-" + adjustedLength + " l 0," + (adjustedLength*2));
																  }
																};
																doDraw();
															}; 
														
														setTimeout(() => {
															audioTest.pause();
															$('#test_mic_play').hide();
															//$('#test_mic').show();
															$('#test_mic_rechear').show();
															isPlayedAudio = 0;
															
															if ( window['fsFile'] ) { try { window['fsFile'].unlink(recPath+recordingfile); } catch (err) { } }
															
														}, 5000);
													}, 1000);
											}, 5000);	
										}
									else
										{
											$('#test_mic_rec').hide();
											$('#test_mic').show();
											$('#microphone_electron_error').modal('show');
										}
								}
								
						}
					
				}
	});

	$(document).on('click', '.heardyourselfyes', function(){
		$('#test_mic').show();
		$('#test_mic_rechear').hide();
	});
	
	$(document).on('click', '.heardyourselfno', function(){
		$('#test_mic').show();
		$('#test_mic_rechear').hide();
		
		$('#notgoodmic').modal('show');
	});
	  
	$(document).off('change', '#select_speakers');
	$(document).on('change', '#select_speakers', function(){
		AgoraRTC.switchSpeaker($(this).val());

        let mediaIds1 = localStorage.getItem(hostlanguage.mediaSetting);
        let mediaIds = JSON.parse(mediaIds1);
		if ( mediaIds )
			{
				mediaIds.speaker = $(this).val();
			}
		else
			{
				mediaIds = {};
				mediaIds.speaker = $(this).val();
			}

        localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaIds));
    });
	
	$(document).off('click', '#camera_cbx input[name="video-type"]');
    $(document).on('click', '#cameraSelect option[name="video-type"]', function(){
	
        var l = $(this).attr('data-keyid');
		
    		let mediaIds1 = localStorage.getItem(hostlanguage.mediaSetting);
    		let mediaIds = JSON.parse(mediaIds1);
		
    		if ( mediaIds )
  			{
    				mediaIds.camera = $(this).val();
  			}
    		else
  			{
    				mediaIds = {};
    				mediaIds.camera = $(this).val();
  			}
			
        localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaIds));

    		if ( window['electron'] )
  			{
    				if(stream1 != undefined && stream1 != null){
    				  if(stream1.length > 0){
      					for(let i in stream1){
      						if (i != l) {
      						  
      						   stream1[i].stop();
      						}
      					}
    				  }
    				}
					console.log('stream333');
    				stream1[l].play('local-media');
  			}
        else if ( !window['ipad'] ) 
        {
    				for(let i in stream1){
    					if( stream1[i].isPlaying() ) { stream1[i].stop(); }
    				}
    				stream1[l].init(function(){
    					stream1[l].play('local-media');
    				}, function (err) {
                
                console.log('err msg - ', err);

      					if (err.msg == 'STREAM_ALREADY_INITIALIZED') 
                {
                    stream1[l].play('local-media', function(errState){
                      stream1[l].resume();
                    });

                    window.mediaAccessAllowed = true;
                    if ($('#continue-join').hasClass('d-none')) {

                        if (currentUserData.userType == Const.USER_TYPE.HOST) 
                        {
                            window.showJoinPreStreaming();
                        } else {
                            if ( $('.countdown-timer').text() == 'Class Started' ) 
                            {
                                $('#continue-join').removeClass('d-none');
                                $('#change-setting-timer').removeClass('d-none');
                                window.displayStreamingTimer();
                                window.showJoinPreStreaming();
                            }
                        }
                    }
                } 
			          else if (err.msg == 'NotReadableError')
                {
                    window.mediaAccessAllowed = false;
                    clearInterval(countRef);
                    $('#continue-join').addClass('d-none');
                    $('#change-setting-timer').addClass('d-none').text('');
                    $('#camera-access-alert').modal('show');

                    if ( currentUserData.userType == Const.USER_TYPE.HOST ) { clearInterval(changeSettingInterval); }
                }                   
    				});
        }
		window.getDevices();
		
		if ( window['electron'] && ( currentUserData.userType == 2 || currentUserData.isMarketplaceChannel == 1 ) ) { setTimeout(function() { window['changeCameraRes'](window['currentResolution']); }, 1000); }
		if ( window['electron'] && currentUserData.userType == 1 && currentUserData.isMarketplaceChannel == 0 ) { setTimeout(function() { window['changeCameraRes']('sd'); }, 1000); }
    
	});
	
	window.autoSetCamera=(mod)=>{
		var cameraValue = '';
		if ( newCameraArray && newCameraArray[mod])
			{
				cameraValue = newCameraArray[mod]['value'];
			}
		window['cameraValue'] = cameraValue;
		let mediaIds1 = localStorage.getItem(hostlanguage.mediaSetting);
		let mediaIds = JSON.parse(mediaIds1);
			
		if ( mediaIds )
			{
					mediaIds.camera = cameraValue;
			}
		else
			{
					mediaIds = {};
					mediaIds.camera = cameraValue;
			}	
		localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaIds));
	}
	
	window.changeCameraSelect=(mod)=>{
	console.log('preStreamingController changeCameraSelect---1');
		var l = mod;
		var cameraValue = '';
		
		if ( newCameraArray && newCameraArray[mod])
			{
				cameraValue = newCameraArray[mod]['value'];
			}
	console.log('preStreamingController changeCameraSelect---2');
		window['cameraValue'] = cameraValue;
		let mediaIds1 = localStorage.getItem(hostlanguage.mediaSetting);
		let mediaIds = JSON.parse(mediaIds1);
			
		if ( mediaIds )
			{
					mediaIds.camera = cameraValue;
			}
		else
			{
					mediaIds = {};
					mediaIds.camera = cameraValue;
			}	
		localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaIds));
		
		/* if ( currentUserData.sessionData.ondemandId && currentUserData.sessionData.ondemandId > 0 && 1 == 2 )
			{
				var deviceId = cameraValue;
				if ( localStreamOnDemand != null ) { 
						localStreamOnDemand.getVideoTracks().forEach(function(track) {
						track.stop();
					});
				}
				globalCameraId = deviceId;
				window.getDevicesOnDemand();
			} */
			
		if ( window['electron'] )
			{
					if(stream1 != undefined && stream1 != null){
					  if(stream1.length > 0){
						for(let i in stream1){
							if (i != l) {
							  console.log('stream8888888');
							   stream1[i].stop();
							}
						}
					  }
					}
					console.log('stream00000');
					stream1[l].play('local-media');
			}
		else if ( !window['ipad'] ) 
			{
						for(let i in stream1){
							if( stream1[i].isPlaying() ) { stream1[i].stop(); }
						}
						stream1[l].init(function(){
							stream1[l].play('local-media');
						}, function (err) {
					
					console.log('err msg - ', err);

							if (err.msg == 'STREAM_ALREADY_INITIALIZED') 
					{
						stream1[l].play('local-media', function(errState){
						  stream1[l].resume();
						});

						window.mediaAccessAllowed = true;
						if ($('#continue-join').hasClass('d-none')) {

							if (currentUserData.userType == Const.USER_TYPE.HOST) 
							{
								window.showJoinPreStreaming();
							} else {
								if ( $('.countdown-timer').text() == 'Class Started' ) 
								{
									$('#continue-join').removeClass('d-none');
									$('#change-setting-timer').removeClass('d-none');
									window.displayStreamingTimer();
									window.showJoinPreStreaming();
								}
							}
						}
					} 
						  else if (err.msg == 'NotReadableError')
					{
						window.mediaAccessAllowed = false;
						clearInterval(countRef);
						$('#continue-join').addClass('d-none');
						$('#change-setting-timer').addClass('d-none').text('');
						$('#camera-access-alert').modal('show');

						if ( currentUserData.userType == Const.USER_TYPE.HOST ) { clearInterval(changeSettingInterval); }
					}                   
						});
			}
			window.getDevices();
	console.log('preStreamingController changeCameraSelect---3');
			
			if ( window['electron'] && ( currentUserData.userType == 2 || currentUserData.isMarketplaceChannel == 1 ) ) { setTimeout(function() { window['changeCameraRes'](window['currentResolution']); }, 1000); }
			if ( window['electron'] && currentUserData.userType == 1 && currentUserData.isMarketplaceChannel == 0 ) { setTimeout(function() { window['changeCameraRes']('sd'); }, 1000); }
	console.log('preStreamingController changeCameraSelect---4');
		
	}

    window.electronCameraAccess = (error) => {
	console.log('preStreamingController electronCameraAccess---1');
        if ( error ) {
		        window.mediaAccessAllowed = false;
            clearInterval(countRef);
            if ( currentUserData.userType == Const.USER_TYPE.HOST ) { clearInterval(changeSettingInterval); }
            $('#continue-join').addClass('d-none');
            $('#change-setting-timer').addClass('d-none').text('');
            $('#camera-access-alert').modal('show');

            let key = $('input[name="video-type"]:checked').attr('data-keyid');
            $('#local-media').html('');
	console.log('preStreamingController electronCameraAccess---2');
        } else {
	console.log('preStreamingController electronCameraAccess---3');
			      window.mediaAccessAllowed = true;
            if ($('#continue-join').hasClass('d-none')) {

                if (currentUserData.userType == Const.USER_TYPE.HOST) 
                {
                    $('#continue-join').removeClass('d-none');
					          window.showJoinPreStreaming();
                    $('#change-setting-timer').removeClass('d-none');

                    if ( $('.countdown-timer').text() == 'Class Started' ) 
                    {
                        window.displayStreamingTimer();
                    }

                } else {
                    if ( $('.countdown-timer').text() == 'Class Started' ) 
                    {
                        $('#continue-join').removeClass('d-none');
						            window.showJoinPreStreaming();
                        $('#change-setting-timer').removeClass('d-none');
                        window.displayStreamingTimer();
                    }
                }
            }
	console.log('preStreamingController electronCameraAccess---4');
        }
    }

    window.removePreScreenSession = function () {
      
	  clearInterval(checkOnlineInterval);
      if ( tempVideoStream )
		{
			tempVideoStream.close();
		}
	 
	  
	if(stream1 != undefined && stream1 != null)
      {
        if(stream1.length > 0){
          for(let l in stream1){
              stream1[l].close();
              stream1[l].stop();
			  
          }
        }
      }
	  
  	  if ( window['electron'] && currentUserData.userType == Const.USER_TYPE.HOST )
  		{
  			// logout here and login later again
  			
			newclient.logout();
			if( channel != undefined ) 
				{ 
					channel.leave(); 
				}
  			window.newclient = undefined;
  			window.channel = undefined;
  		}
	
      if(stream2 != undefined && stream2 != null) {
          stream2.close();
		  
	 	  
      }
	  
	  tempVideoStream = null;
	  stream1 = [];
	  stream2 = undefined; 
	  if ( window['globalAgora'] && window['globalAgora']['agora'] )
		{
			window['globalAgora']['agora'] = undefined;
		}
			
	}

    function removeSession(){
     // localStorage.removeItem("userData");
      localStorage.removeItem("tempUsers");
      localStorage.removeItem("video-resolution");
      localStorage.removeItem("hostStreamMuted");
      localStorage.removeItem("sessionList");
      localStorage.removeItem("recordingStarted");
    }

  window.signalHandler = function(uid, signalData, userType) {

    console.log('Function - signalHandler - ' + signalData + ' - email: ' + uid);

    let resultant = signalData.split(sep);
         
    if(userType == Const.USER_TYPE.HOST) { // Host

      if(resultant[0] == RTMConst.SWITCH_VIDEO_BROADCAST) {
		  
		let status = false;
		if (resultant[1] == 1) {
			status = true;
		}
		  
          let userId = convertEmailToId(uid);
          addUserAttribute(userId, 'broadcastVideo', status);
      } else if(resultant[0] == RTMConst.WELCOME) {

          if(uid.includes("RM-") === false) {
              let userList = getTempUsers();
              let becomeBroadcasterCount = 0;
              let broadcasterIds = [];
              let userId = convertEmailToId(uid);

              window.updateStatusMember(userId, 'online');

              let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "receive", "userId": currentUserData.id, "toFromId": userId, "message": "216", "details": JSON.stringify({"action": "Welcome"}), "timestamp": Util.getCurrentTimestamp()};
              sessionDataStore.addSessionData(addObject);

              if(userList != '') {
                
                for(let i = 0; i < userList.length; i++){
                    if(userList[i].hasOwnProperty('isSubscribe') && userList[i].isSubscribe === 1) {
                        becomeBroadcasterCount++;
                        broadcasterIds.push(parseInt(userList[i].id));
                    }
                }
              }

              addUserAttribute(userId, 'loggedIn', 1);

              if (becomeBroadcasterCount < currentUserData.default.maxUserLimit || broadcasterIds.indexOf(userId) !== -1) {
                  addUserAttribute(userId, 'isSubscribe', 1);
              } else {
                  addUserAttribute(userId, 'isSubscribe', 0);
              }

              incrementcountAtHost(uid, "welcome");

              if( $('#joinee-' + userId).length == 0 ){
                  let joinerName = getUserDataFromList(userId, 'firstName')+' '+(getUserDataFromList(userId, 'lastName') != null ? getUserDataFromList(userId, 'lastName') : '');
                  $('#joiners').append('<p class="text-white" id="joinee-'+userId+'">'+joinerName+'</p>');
              }
          }
      } else if(resultant[0] == RTMConst.CAMERA_MIC_PERMISSION) {          
          console.log('---------230---------------camera access allowed/denied')

          let userId = convertEmailToId(uid);
          addUserAttribute(userId, 'cameraAccess', resultant[1]);
          addUserAttribute(userId, 'micAccess', resultant[2]);

          window.updateStatusMember(userId, 'cameraAccess', resultant[1]);
          window.updateStatusMember(userId, 'micAccess', resultant[2]);
      } else if(resultant[0] == "1000") {
          let userId = convertEmailToId(uid);
          addUserAttribute(userId, 'currentStatus', 1);
          addUserAttribute(userId, 'subscribeTime', (new Date()).getTime());
          addUserAttribute(userId, 'isSubscribe', 0);
      } else if(resultant[0] == RTMConst.CHAT_SYNC) {

          let sessionChats = JSON.parse(localStorage.getItem('chats'));
          let chatArray = [];

          sessionChats.messages.forEach((chatData) => {
              if ( (chatData.conversation == 'channel' && chatData.type == 'send') || 
                  (chatData.conversation == 'p2p' && chatData.type == 'send' && chatData.toUserEmail == uid)
               ) 
              {
                  chatArray.push(chatData);
              }
          });

          let text = RTMConst.CHAT_SYNC + sep + JSON.stringify(chatArray);
          sendMessage(uid, text);
      }
    } else { // Attendy
      
      if(resultant[0] == RTMConst.SWITCH_VIDEO_BROADCAST) {

		  let status = false;
          if (resultant[1] == 1) 
			  {
				  status = true;
			  }
			  
          let userId = convertEmailToId(uid);
          addUserAttribute(userId, 'broadcastVideo', status);
      } else if(resultant[0] == RTMConst.WELCOME) {

        let userId = uid.includes("RM-") === false ? convertEmailToId(uid) : uid;

        incrementcountAtAttendies(uid, "welcome");

        if(getUserDataFromList(uid, 'userType') == Const.USER_TYPE.HOST){        

            $('#online_state').removeClass('d-none');
            $('#offline_state').addClass('d-none');
			      window.updateOnlineStatusHost();
            window.updateStatusMember(userId, 'online');

            let welcomeMessage = "Hi " + currentUserData.firstName + ", this is "  + currentUserData.sessionData.hostFirstName + ", welcome to <strong>" + currentUserData.sessionData.channelName + "</strong> live class <strong>" + currentUserData.sessionData.name + "</strong>";
            $('#newmsg').html(welcomeMessage);
            let permissionInterval = setInterval(function() {
                if ( window.mediaAccessAllowed !== null )
                {
                    clearInterval(permissionInterval);

                    let text = RTMConst.CAMERA_MIC_PERMISSION + sep;
                    text = text + (localStorage.getItem('cameraAccessAllowed') == "true" ? 1 : 0);
                    text = text + sep + (localStorage.getItem('microphoneAccessAllowed') == "true" ? 1 : 0);
					sendMessage(currentUserData.sessionData.hostEmail, text);
                }
            }, 100);
        } else {
            window.updateStatusMember(userId, 'online');
        }

        if (userId != currentUserData.sessionData.hostId)
        {
            addUserAttribute(userId, 'currentStatus', 1);
        }

        if (resultant[1] == 1) {
            hasSessionStarted = true;
            $('.countdown-timer').text('Class Started');
            window.play_notification_sound();

            clearInterval(checkOnlineInterval);

            var bandwidthCheckCounter = setInterval(function() {

              if(localStorage.getItem("video-resolution") != null && window.mediaAccessAllowed === true) {
                  clearInterval(bandwidthCheckCounter);

                  let text = RTMConst.CAMERA_MIC_PERMISSION + sep;
                  text = text + (localStorage.getItem('cameraAccessAllowed') == "true" ? 1 : 0);
                  text = text + sep + (localStorage.getItem('microphoneAccessAllowed') == "true" ? 1 : 0);
                  sendMessage(currentUserData.sessionData.hostEmail, text);

                  window.play_notification_sound();
				          window.showJoinPreStreaming();
              } else {
                  if ($('input[name="video-type"]').length > 1 && window.mediaAccessAllowed === false) {
                      clearInterval(bandwidthCheckCounter);

                      let text = RTMConst.CAMERA_MIC_PERMISSION + sep;
                      text = text + (localStorage.getItem('cameraAccessAllowed') == "true" ? 1 : 0);
                      text = text + sep + (localStorage.getItem('microphoneAccessAllowed') == "true" ? 1 : 0);
                      sendMessage(currentUserData.sessionData.hostEmail, text);
                  }
              }
            }, 1000);
        }
      } else if(resultant[0] == RTMConst.SETTINGS) {
          currentUserData.sessionData.showOtherParticipants = parseInt(resultant[1]);

          if (parseInt(resultant[2]) === 1) {
              localStorage.setItem('recordingStarted', true);
          } else {
              localStorage.removeItem('recordingStarted');
          }

          if (parseInt(resultant[3]) === 1) {
              currentUserData.unmuteAllEnabled = true;
          } else {
              currentUserData.unmuteAllEnabled = false;
          }

          if (parseInt(resultant[4]) === 1) {
              currentUserData.sessionData.switchHostParticipant = parseInt(resultant[4]);
          }

          currentUserData.sessionData.turnoffRoomSetup = parseInt(resultant[6]);

          localStorage.setItem('userData', JSON.stringify(currentUserData));
		  
    		  if ( currentUserData )
    			{
    				roomSetupStatus = currentUserData.sessionData.turnoffRoomSetup;	
    			}
    		  
          checkRoomSetupStatus(roomSetupStatus)		
      } else if(resultant[0] == RTMConst.CHAT_SYNC) {
          let chats = JSON.parse(resultant[1]);
          chats.forEach((chatData) => {
              window.syncChat(chatData);
          });
      }
    }

    if(resultant[0] == RTMConst.CHAT) {
        if(uid.includes("RM-")) 
        {
            uid = uid.split('RM-')[1];
        }

        let peerName = '';
        if (resultant[3] != undefined) 
        {
            let userDetails = getUserDetails(resultant[3]);
            peerName = userDetails.firstName;
        }

        console.log('##resultant --- ', uid);
        window.onReceiveMessage(getUserDetails(uid), resultant[1], "p2p", resultant[2], peerName);
    }
	
	if ( resultant[0] == RTMConst.EJECT_PARTICIPANT )
		{
			$('#ejectedPop').removeClass('d-none');
			setTimeout(function(){
				$('.close_streaming').trigger('click');
			}, 1500);
			
		}
    // TODO verify these RTMs are from user's own remote.
      if (resultant[0] == RTMConst.REMOTE_VOLUME_CHANGE_FOR_INSTRUCTOR && uid.includes("RM-")) {
          window['reduceHostVolume'](resultant[1]);
      }

      if (resultant[0] == RTMConst.REMOTE_VOLUME_CHANGE_FOR_MUSIC && uid.includes("RM-")) {
          window['changeFmVolumeHost'](resultant[1]);
      }	
  }

  window.channelMsgHandler = function(msg, senderId, userType, isFromOnDemand) {
      console.log('Func - channelMsgHandler - ', msg, senderId, userType);

      let res1 = msg.split(sep);
	  
      let addObject = null;

      if(res1[0] == RTMConst.JOINED) { 

        let userId = senderId.includes("RM-") === false ? convertEmailToId(senderId) : senderId;
        
        let localUserDta = JSON.parse(localStorage.getItem("userData"));

        if (currentUserData.userType == Const.USER_TYPE.HOST) {

            addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "receive", "userId": currentUserData.id, "toFromId": userId, "message": "208", "details": JSON.stringify({"action": "Joined"}), "timestamp": Util.getCurrentTimestamp()};
            sessionDataStore.addSessionData(addObject);

            if(senderId.includes("RM-")) {
                let text = RTMConst.WELCOME + sep + 0;
                sendMessage(senderId, text);
            } else {
                let userList = getTempUsers();
                let becomeBroadcasterCount = 0;
                let broadcasterIds = [];

                if(userList != '') {
                  
                  for(let i = 0; i < userList.length; i++){
                      if(userList[i].hasOwnProperty('isSubscribe') && userList[i].isSubscribe === 1){
                          becomeBroadcasterCount++;
                          broadcasterIds.push(parseInt(userList[i].id));
                      }
                  }
                }

                addUserAttribute(userId, 'loggedIn', 1);

                if (becomeBroadcasterCount < currentUserData.default.maxUserLimit || broadcasterIds.indexOf(userId) !== -1) {

                    let text = RTMConst.WELCOME + sep + 0;
                    sendMessage(senderId, text);

                    addUserAttribute(userId, 'isSubscribe', 1);
                } else {
                    let text = RTMConst.WELCOME + sep + 0;
                    sendMessage(senderId, text);

                    addUserAttribute(userId, 'isSubscribe', 0);
                }
            }
        } else {
            let text = RTMConst.WELCOME + sep + 0;
            sendMessage(senderId, text);

            if (senderId == currentUserData.sessionData.hostEmail) {

                let text = RTMConst.CAMERA_MIC_PERMISSION + sep;

                text = text + (localStorage.getItem('cameraAccessAllowed') == "true" ? 1 : 0);
                text = text + sep + (localStorage.getItem('microphoneAccessAllowed') == "true" ? 1 : 0);

                sendMessage(currentUserData.sessionData.hostEmail, text);
            }
        }

        if(getUserDataFromList(userId, 'userType') == Const.USER_TYPE.HOST){

            addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": currentUserData.id, "toFromId": userId, "message": "216", "details": JSON.stringify({"action": "Welcome"}), "timestamp": Util.getCurrentTimestamp()};
            sessionDataStore.addSessionData(addObject);

            $('#online_state').removeClass('d-none');
            $('#offline_state').addClass('d-none');
		        window.updateOnlineStatusHost();

            let welcomeMessage = "Hi " + currentUserData.firstName + ", this is "  + currentUserData.sessionData.hostFirstName + ", welcome to <strong>" + currentUserData.sessionData.channelName + "</strong> live class <strong>" + currentUserData.sessionData.name + "</strong>";
            $('#newmsg').html(welcomeMessage);
            window.play_notification_sound();
        }
      } else if (res1[0] == RTMConst.SWITCH_VIDEO_BROADCAST)
      {
          let status = false;
          if (res1[1] == 1) {
              status = true;
          }

          let userId = convertEmailToId(senderId);
          addUserAttribute(userId, 'broadcastVideo', status);
      } else if (res1[0] == RTMConst.SHOW_SESSION_RECORDING_ICON) {
          if (parseInt(res1[1]) === 1) {
              localStorage.setItem('recordingStarted', true);
          } else {
              localStorage.removeItem('recordingStarted');
          }
		  currentUserData.sessionData.recordingInSessionStarted = parseInt(res1[1]);
		  localStorage.setItem('userData', JSON.stringify(currentUserData));
      } else if (res1[0] == RTMConst.SHOW_EMOJIS) {
          currentUserData.sessionData.showEmojisToParticipants = parseInt(res1[1]);
          localStorage.setItem('userData', JSON.stringify(currentUserData));
      } else if(res1[0] == RTMConst.SESSION_STARTED) {

        clearInterval(checkOnlineInterval);
        hasSessionStarted = true;

        let userId = convertEmailToId(senderId);
        let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "receive", "userId": currentUserData.id, "toFromId": userId, "message": "222", "details": JSON.stringify({"action":"startSession", "msg":"Class is started"}), "timestamp": Util.getCurrentTimestamp()};
        sessionDataStore.addSessionData(addObject);

        $('.countdown-timer').text('Class Started');

          var bandwidthCheckCounter = setInterval(function() {

              if(localStorage.getItem("video-resolution") !== null && window.mediaAccessAllowed === true) {
                  
                  clearInterval(bandwidthCheckCounter);
				 if (!currentUserData.isMarketplaceChannel || (currentUserData.isMarketplaceChannel && currentUserData.isMarketplaceChannel == 0))
					{
						window.play_notification_sound();
					}
                  window.showJoinPreStreaming();
              } else {
                  if ($('input[name="video-type"]').length > 1 && window.mediaAccessAllowed === false) {
                      clearInterval(bandwidthCheckCounter);
                  }
              }
          }, 1000);
      } else if(res1[0] == RTMConst.UNMUTE_ALL) {
          currentUserData.unmuteAllEnabled = true;
          localStorage.setItem('userData', JSON.stringify(currentUserData));
      } else if(res1[0] == RTMConst.MUTE_ALL) {
          currentUserData.unmuteAllEnabled = false;
          localStorage.setItem('userData', JSON.stringify(currentUserData));
      } else if(res1[0] == RTMConst.SETTINGS) {
          currentUserData.sessionData.showOtherParticipants = parseInt(res1[1]);
          localStorage.setItem('userData', JSON.stringify(currentUserData));
      } else if(res1[0] == RTMConst.SWITCH_HOST_PARTICIPANT) {
		  console.log('SWITCH_HOST_PARTICIPANT');
          currentUserData.sessionData.switchHostParticipant = parseInt(res1[1]);
          localStorage.setItem('userData', JSON.stringify(currentUserData));
      } else if(res1[0] == RTMConst.ROOM_SETUP_TURN_OFF) {
          currentUserData.sessionData.turnoffRoomSetup = parseInt(res1[1]);
          localStorage.setItem('userData', JSON.stringify(currentUserData));
		  checkRoomSetupStatus(parseInt(res1[1]));
      } else if(res1[0] == RTMConst.CHAT) {
          if(senderId.includes("RM-")) 
          {
              senderId = senderId.split('RM-')[1];
          }
          
          window.onReceiveMessage(getUserDetails(senderId), res1[1], "channel", res1[2]);
      } else if(res1[0] == RTMConst.CALCULATE_DIMENSIONS) {
          currentUserData.sessionData.calculateAssessmentDimensions = parseInt(res1[1]);
          localStorage.setItem('userData', JSON.stringify(currentUserData));
      } else if(res1[0] == RTMConst.SESSION_COMPLETED) {
			$("#online_state").addClass("d-none");
			$("#offline_state").removeClass("d-none");
			window.updateOfflineStatusHost();
      }
	   
	  if ( res1[0] == 'modifyGlobalObject' && currentUserData.sessionData.ondemandId > 0 && window.hostUserId ) 
		{
			let activityObject = res1[1];
			let activityName = res1[2];
			
			console.log('modifyGlobalObject id', window.hostUserId);
			
			if ( window['userWhiteboard'][window.hostUserId] ) 
				{
					var currentObject = window['userWhiteboard'][window.hostUserId].activityBuilderContent.activityBuilderObject;
					window['getCurrentObjectInnit'] = activityObject;
					
					if ( activityName == 'reset' || activityName == '' ) { window['userWhiteboard'][window.hostUserId].changeGlobalObject(JSON.stringify(currentObject[activityName]), activityName);  }
					else { window['userWhiteboard'][window.hostUserId].changeGlobalObjectRTM(activityObject, activityName); }
				}
		}
		
	  if( res1[0] == "changeGlobalCounter" && currentUserData.sessionData.ondemandId > 0 && window.hostUserId ) 
		{
			if ( window['userWhiteboard'][window.hostUserId] ) { window['userWhiteboard'][window.hostUserId].changeGlobalCounter(res1[1], res1[2]); }
		}
	   
	  if( res1[0] == "modifyCustomVariable" && currentUserData.sessionData.ondemandId > 0 && window.hostUserId ) 
		{
			let customObject = JSON.parse(res1[1]);
			console.log('modifyCustomVariable RTM received', customObject);
			if ( window.setCustomObject ) { window.setCustomObject(customObject[0], customObject[1], customObject[2], window.hostUserId);  console.log('modifyCustomVariable function called'); }
		}
		
	  if( res1[0] == 'feedFm' && currentUserData.sessionData.ondemandId > 0 )
		{
			if ( res1[1] == 'play' )
				{
					//rtm.invoke({'code': 75, 'func': 'play', 'param': res1[2]});
					
					/* this.playerFunctions.playPlayer(payload.param);
					this.setState({isPlayingFM: true}, ()=>{
						$('.participant_header').addClass('fmControlAlign');
					}); */
					
					if ( window['currentStationId'] != res1[2] ) { window['playPlayerDemand'](res1[2]); }
				}
				
			if ( res1[1] == 'stop' )
				{
					//rtm.invoke({'code': 75, 'func': 'stop'});
					
					/* this.playerFunctions.stopPlayer();
					this.setState({isPlayingFM: false}, ()=>{
						$('.participant_header').removeClass('fmControlAlign');
					});
					window['reduceHostVolume'](75); */
					
					window['stopPlayerDemand']();
				}
		}
	   
	  if ( currentUserData )
			{
				if ( currentUserData.sessionData.turnoffRoomSetup != undefined && currentUserData.sessionData.turnoffRoomSetup == 0 )
					{
						roomSetupStatus = currentUserData.sessionData.turnoffRoomSetup;	
					}
				else 
					{
						roomSetupStatus = 1;	
					}					
				
			}
		checkRoomSetupStatus(roomSetupStatus)
	  
    }

    window.channelSignalHandler = function(signalData, userType) {

        signalData = JSON.parse(signalData);

        if(signalData.code == RTMConst.JOINED){
            if(userType == Const.USER_TYPE.HOST) {
                incrementcountAtHost(signalData,userType);        
            } else {
                incrementcountAtAttendies(signalData,userType);    
            }
        }
    }

    function incrementcountAtAttendies(signalData, userType) {

        if (userType == "welcome") {
                 
          let prestrecount = $("#totalonline").html();
      
          prestrecount = parseInt(prestrecount);

          let substring="RM-";
          let output= signalData.includes(substring);

          let memberID = convertEmailToId(signalData);
		  
          let uuCount = null;

          if(output != true  && getUserDataFromList(memberID, 'userType') == Const.USER_TYPE.PARTICIPANT) {
              newArr121.push(signalData);

              var unique = newArr121.filter(function(itm, i, a) {
                return i == newArr121.indexOf(itm);
            });

            uuCount = unique.length+1;
          } else {
             uuCount =prestrecount;
          }

          if (uuCount < 1) {
            uuCount = 0;
          }

          $("#totalonline").empty();    
          $("#totalonline").html(uuCount);
        } else{

        var count3 = $("#totalonline").html();
      
        count3 = parseInt(count3);
      
        if (signalData.msgtype == "Joined") {
          let str = signalData.message;
          let res = str.split(sep);
          let hostEmail = currentUserData.sessionData.hostEmail;
      
          if (res[1] == hostEmail) {
            $("#online_state").removeClass("online-status");
            $("#online_state").addClass("online-status");
			      window.updateOnlineStatusHost();
          }

          let substring="RM-";
          let output= signalData.member.includes(substring);
   
          let memberID = convertEmailToId(signalData.member);
          let count4 = null;

          if(output != true  && getUserDataFromList(memberID, 'userType') == Const.USER_TYPE.PARTICIPANT)
          {
            newArr121.push(signalData.member);
              var unique1 = newArr121.filter(function(itm, i, a) {
                return i == newArr121.indexOf(itm);
            });

            count4 = unique1.length+1;
          } else {
            count4 = count3;
          }
      
          $("#totalonline").empty();
          $("#totalonline").html(count4);
        } else if (signalData.msgtype == "left") {
          let str = signalData.message;
          let res = str.split(sep);
          let hostEmail = currentUserData.sessionData.hostEmail;
      
          if (res[1] == hostEmail) {
            $("#online_state").addClass("d-none");
            $("#offline_state").removeClass("d-none");
			window.falseJoinPreStreaming();
			window.updateOfflineStatusHost();
          }

          let substring = "RM-";
          let output = signalData.member.includes(substring);
   
          let memberID = convertEmailToId(signalData.member);
          let count4 = null;

          if(output != true  && getUserDataFromList(memberID, 'userType') == Const.USER_TYPE.PARTICIPANT)
          {
              newArr121 = newArr121.filter(item => !signalData.member.includes(item))
       
              let unique12 = newArr121.filter(function(itm, i, a) {
                return i == newArr121.indexOf(itm);
              });

              count4 = unique12.length+1;
             }else{
              count4 = count3 > 0 ? count3 : 0;
             }
      
            $("#totalonline").empty();
            $("#totalonline").html(count4);
        }
      }
    }

    function incrementcountAtHost(signalData, userType) {

        if (userType == "welcome") {
                 
            let prestrecount = $("#totalonline").html();

            prestrecount = parseInt(prestrecount);

            let substring = "RM-";
            let output= signalData.includes(substring);

            let memberID = convertEmailToId(signalData);
            let uuCount = null;

            if(output != true  && getUserDataFromList(memberID, 'userType') == Const.USER_TYPE.PARTICIPANT)
            {

                newArr122.push(signalData);

                var unique = newArr122.filter(function(itm, i, a) {
                    return i == newArr122.indexOf(itm);
                });

                uuCount = unique.length;
            } else {
               uuCount= prestrecount;
            }

            if (uuCount < 1) {
                uuCount = 0;
            }

            $("#totalonline").empty();
            $("#totalonline").html(uuCount);
        } else {

            var count = $("#totalonline").html();
            count = parseInt(count);

            if (currentUserData.userType == Const.USER_TYPE.HOST) {
                $("#online_state").removeClass("online-status");
                $("#online_state").addClass("online-status");
				window.updateOnlineStatusHost();
            }
      
            if (signalData.msgtype == "Joined") {

                let substring = "RM-";
                let output = signalData.member.includes(substring);
         
                let memberID = convertEmailToId(signalData.member);
                let count1 = null;

                if(output != true  && getUserDataFromList(memberID, 'userType') == Const.USER_TYPE.PARTICIPANT)
                {
                  newArr122.push(signalData.member);
           
                  let unique = newArr122.filter(function(itm, i, a) {
                       return i == newArr122.indexOf(itm);
                  });

                  count1= unique.length;
                } else {
                    count1 = count;
                }
        
                $("#totalonline").empty();
                $("#totalonline").html(count1);
            } else if (signalData.msgtype == "left") {

                let substring="RM-";
                let output= signalData.member.includes(substring);
    
                let memberID = convertEmailToId(signalData.member);
                let count1 = null;

                if(output != true  && getUserDataFromList(memberID, 'userType') == Const.USER_TYPE.PARTICIPANT)
                {
                    newArr122 = newArr122.filter(item => !signalData.member.includes(item))

                    let unique45 = newArr122.filter(function(itm, i, a) {
                      return i == newArr122.indexOf(itm);
                    });
                        
                    count1 = unique45.length;

                    count1 = count1 > 0 ? count1 : 0;
                } else {
                      count1 = count > 0 ? count  : 0;
                }
               
                $("#totalonline").empty();
                $("#totalonline").html(count1);
            }
        }
    }

    window.leaveLogout = function() {
		
		if ( window['localStreamOnDemandGlobal'] )
			{ 
				window['localStreamOnDemandGlobal'].getVideoTracks().forEach(function(track) { track.stop(); });
				window['localStreamOnDemandGlobal'] = null;
			}
		
        leave_channel();
        removeSession();
		
		if ( window['eventCurrent'] && window['eventCurrent']['adminReportsOngoingSessions'] )
			{
				window['eventCurrent']['adminReportsOngoingSessions'].close();
				window['eventCurrent']['adminReportsOngoingSessions'] = false;
			}
			
		if ( window.soundPlay ) { window.soundPlay.stopAudio(); }
		if ( window['userWhiteboard'][currentUserData.id] ) 
			{ 
				window['userWhiteboard'][currentUserData.id].soundPlay.stopAudio();
				window.removeUserWhiteboard(parseInt(currentUserData.id)); 
			}
			
		if ( document.getElementById('replayClassVideo') ) { document.getElementById('replayClassVideo').remove(); }
    }

    window.deviceAccessAlert = function (type) {
        $('#device-access-msg').modal(type);
    }


    window.multimediaAccessAlert = function () {
		    window.showJoinPreStreaming();
        
        let duration = parseInt(currentUserData.default.streamRedirectDuration);

        let redirectTimer = setInterval( function() {
            duration--;

            if(duration <= 0){
                clearInterval(redirectTimer);
				        window.showJoinPreStreaming();
            } else {
                $('#stream-joining-timer').text(duration);
            }
        }, 1000 );
    }

    window.joinWithoutCameraAlertClose = function () {
        $('#media-access-alert').modal('hide');
		$('#camera-detection-alert').modal('hide');
    }
	
	window.joinWithoutMicrophone = function () {
        $('#mic-detection-alert').modal('hide');
    }
	
	function showMicDetectionAler (){
		if (currentUserData.userType == Const.USER_TYPE.HOST) 
			{
				$('#mic-detection-alert').modal('show');
			}
		else
			{
				//for member not mandatory
				//$('#mic-detection-alert').modal('show');
			}
	}
	
	function showMediaAccessAlert (){
		if (currentUserData.userType == Const.USER_TYPE.HOST) 
			{
				$('#media-access-alert').modal('show');
			}
		else
			{
				//for member not mandatory
				//$('#media-access-alert').modal('show');
			}
	}

    // Get user specific data
    function getUserDataFromList(id, key){
        let userList = getTempUsers();
        if(userList != ''){
          
          for(let i= 0; i < userList.length; i++){
            if(userList[i].hasOwnProperty(key) && id == userList[i].id){
              return userList[i][key];
            } else if(userList[i].hasOwnProperty(key) && id == userList[i].email){
              return userList[i][key];
            }
          }
        }
        return '';
    }

    function addUserAttribute(id, key, value){
        let tempUsers = getTempUsers();

        if(tempUsers != null){
          for(let i in tempUsers){
            if(tempUsers[i].id == id){
              tempUsers[i][key] = value;
            }
          }
        }
		
		if ( window.updateParticipantsData )
			{
				window.updateParticipantsData(id, key, value);
			}
          
        localStorage.setItem("tempUsers", JSON.stringify(tempUsers));
    }

    function removeUserAttribute(id, key){

        let tempUsers = getTempUsers();

        if(tempUsers != null){
          for(let i in tempUsers){
            if(tempUsers[i].hasOwnProperty(key) && tempUsers[i].id == id){
              delete tempUsers[i][key];
            }
          }
        }
          
        localStorage.setItem("tempUsers", JSON.stringify(tempUsers));
    }

    function checkAvailableAtRTM(peerId, text){}
    window.logoutRemoteUser = () => {}

    $(document).ready(function(){
	console.log('preStreamingController document.ready---1');

        window.addEventListener('online', () => {
          toast.info('The connectivity is back', {
            position: toast.POSITION.TOP_RIGHT,
            hideProgressBar: true,
            autoClose: 5000
          });
        });
	console.log('preStreamingController document.ready---2');

        window.addEventListener('offline', () => {
          toast.warn('The app is running offline', {
            position: toast.POSITION.TOP_RIGHT,
            hideProgressBar: true,
            autoClose: 5000
          });
          clearInterval(checkOnlineInterval);
        });
	console.log('preStreamingController document.ready---3');

        if(currentUserData.userType == Const.USER_TYPE.PARTICIPANT) {
          $('#totalonline').text(1);
        }

        Util.popupateHostResolution(currentUserData.default);
        Util.popupateParticipapntResolution(currentUserData.default); 
	console.log('preStreamingController document.ready---4');

        if (currentUserData.onDemand == undefined) {
            getSessionEmojis();
        }
	console.log('preStreamingController document.ready---5');

        checkRoomSetupStatus(roomSetupStatus);
	console.log('preStreamingController document.ready---6');
        
        checkHostPlaylist();
	console.log('preStreamingController document.ready---7');

        $('#proceed').on('click', function(){
            $('#multi-media-access-alert').modal('hide');
            $('#mic-camera-select-alert').modal('hide');
		        window.showJoinPreStreaming();
        });

        $('#change-setting').on('click', function(){
            $('#mic-camera-select-alert').modal('hide');
            $('#continue-join').removeClass('d-none');
			      window.showJoinPreStreaming();
            $('#change-setting-timer').removeClass('d-none');

            let duration = parseInt(currentUserData.default.changeMediaTimer);
            
            changeSettingInterval = setInterval( function() {
                $('#change-setting-timer').html(duration < 0 ? 0 : duration);

                if ($('#multi-device-login-alert').hasClass('show') === false) {
                  if(duration <= 0){
					           window.showJoinPreStreaming();
                  }
                  duration--;
                } else {
                  clearInterval(changeSettingInterval);
                }
            }, 1000 );
        });

        $('.try-again').on('click', function(){

            $('#media-access-alert').modal('hide');

            if (window['electron']) {
                $('#electron_permission').modal('show');
            } else {
                
                let deviceType = localStorage.getItem('cameraAccessAllowed') == "false" ? "camera" : "mic";

                switch (localStorage.getItem('mediaAccessError')) {

                    case 'NotAllowedError':
                                  window.showMediaErrorMsg(deviceType);
                                  $('#permission_mac_chrome').modal('show');
                                  break;
                    case 'DEVICES_NOT_FOUND': 
                                  $('#device_not_found').modal('show');
                                  break;
                    case 'PERMISSION_DENIED': 
                                  window.showMediaErrorMsg(deviceType);
                                  $('#permission_mac_chrome').modal('show');
                                  break;
                    case 'NotReadableError': 
                                  window.showMediaErrorMsg(deviceType);
                                  $('#permission_mac_chrome').modal('show');
                                  break;
                    case 'NotFoundError': 
                                  $('#device_not_found').modal('show');
                                  break;
                }
            }
        });

        $('.try-again-access').on('click', function(){
			$('#camera-detection-alert').modal('hide');
			window.getDevices();
			$('#electron_permission').modal('hide');
			$('#microphone_electron_error').modal('hide');
			$('#permission_mac_chrome').modal('hide');
			$('#device_not_found').modal('hide');
        });

        if( currentUserData.userType == Const.USER_TYPE.HOST && localStorage.getItem("hostSettings") !== null )
        {
	console.log('preStreamingController document.ready---8');
            //let settings = JSON.parse(localStorage.getItem("hostSettings"));
            let settingsInSession = JSON.parse( localStorage.getItem('settingsInSession')); 
			if ( settingsInSession )
				{
					if ( settingsInSession['sessionId'] == currentUserData.sessionData.id )
						{	
							var startRecNum = 0;
							var startMusicNum = 0;
							var showNum = 0;
							var switchHostAndPartNum = 0;
							var disableNotNum = 0;
							var calcAssessmentNum = 0;
							var turnoffRoomSetupNum = 0;
							
							if ( settingsInSession['StartRecordSession'] === true || settingsInSession['StartRecordSession'] == 1 )
								{
									startRecNum = 1;
								}
								
							if ( settingsInSession['StartMusicSession'] === true || settingsInSession['StartMusicSession'] == 1 )
								{
									startMusicNum = 1;
								}	
							
							if ( settingsInSession['showOtherParticipants'] === true || settingsInSession['showOtherParticipants'] == 1 )
								{
									showNum = 1;
								}
								
							if ( settingsInSession['switchHostParticipant'] === true )
								{
									switchHostAndPartNum = 1;
								}

							if ( settingsInSession['disableNotificationSound'] === true )
								{
									disableNotNum = 1;
								}
							
							if ( settingsInSession['calculateAssesment'] === true || settingsInSession['calculateAssesment'] == 1 )
								{
									calcAssessmentNum = 1;
								}	
							
							if ( settingsInSession['turnoffRoomSetup'] === true )
								{
									turnoffRoomSetupNum = 1;
								}	
							
							currentUserData['sessionData']['StartRecordSession'] = startRecNum;
							currentUserData['sessionData']['StartMusicSession'] = startMusicNum;
							currentUserData['sessionData']['showOtherParticipants'] = showNum;
							currentUserData['sessionData']['CustomResolutionHigh'] = settingsInSession['CustomResolutionHigh'];
							currentUserData['sessionData']['switchHostParticipant'] = switchHostAndPartNum;
							currentUserData['sessionData']['disableNotificationSound'] = disableNotNum;
							currentUserData['sessionData']['calculateAssesment'] = calcAssessmentNum;
							currentUserData['sessionData']['turnoffRoomSetup'] = turnoffRoomSetupNum;
						
							localStorage.setItem('userData', JSON.stringify(currentUserData));
						}
				}
	console.log('preStreamingController document.ready---9');
			
			/*
            if( settings.sessionId == currentUserData.sessionData.id )
            {
                currentUserData.sessionData.showOtherParticipants = settings.showOtherParticipants;
                currentUserData.sessionData.switchHostParticipant = settings.switchHostParticipant;
                currentUserData.sessionData.disableNotificationSound = settings.disableNotificationSound;

                localStorage.setItem('userData', JSON.stringify(currentUserData));
				 console.log('*****---set here----*****');
            }
            else
            {
                localStorage.removeItem("hostSettings");
            }
			*/
        }
	console.log('preStreamingController document.ready---10');
    });
   
    window.play_notification_sound = function() {
      audio.play();
    }
    
    setTimeout(function(){
      reminderMail(); //CALL FOR REMIDER MAIL
    }, 10000);

    window.checkSessionUser = (email) => {

        let userList = getTempUsers();

        if(userList != '') {

          var sessionUserExists = false;

          for(let i = 0; i < userList.length; i++){
              if(userList[i].email == email){
                  sessionUserExists = true;
              }
          }

          if (sessionUserExists === true) {
              return true;
          } else {
              return false;
          }
        } else {
            return false;
        }
    }

    //CALL FOR SEND EMAIL TO PARTICIPANT REMINNDER AND HOST REMINDER
    function reminderMail() 
    {   
		if ( currentUserData.sessionData.replayClassId > 0 || currentUserData.sessionData.ondemandId > 0 ) { return false; }
		
		localStorage.setItem("remindLog", true);
		var hostOnline = $('#checkOnlineStatus').hasClass('offline_status');
       let prestrecount = parseInt($("#totalonline").text());
       let remindLogs = localStorage.getItem("remindLog");

       var xhr = new XMLHttpRequest();
       xhr.withCredentials = false;
       
       xhr.addEventListener("readystatechange", function () {
         if (this.readyState === 4) {
          console.log("RESPONSE CODE IN REMINDER FUNCTION======>>>>" ,this.responseText);
         }
       });

        console.log("PARTICIPANT -->",prestrecount," |HOSTONLINE",hostOnline," |rl -",remindLogs);

        var sessionId = JSON.stringify({
          "sessionid": currentUserData.sessionData.id,
		  "userName": currentUserData.firstName + ' ' + currentUserData.lastName
        });

        if((prestrecount===0 || isNaN(prestrecount) || prestrecount==="NaN") && (remindLogs===true || remindLogs==="true")){

          console.log("hostmail IF PARTICIPANT -->",prestrecount," |HOSTONLINE",hostOnline," |rl -",remindLogs);
          xhr.open("POST", Const.BASE_API_PATH+"/api/v1/newsletter/hostmail"); 
          xhr.setRequestHeader("content-type", "application/json"); 
          xhr.send(sessionId);
        }

        if ((prestrecount===1 || prestrecount==="1") && (hostOnline===true || hostOnline==="true")){
          console.log("participantmail IF PARTICIPANT -->",prestrecount," |HOSTONLINE",hostOnline," |rl -",remindLogs);
         xhr.open("POST", Const.BASE_API_PATH+"/api/v1/newsletter/participantmail");  
          xhr.setRequestHeader("content-type", "application/json");
          xhr.send(sessionId); 
        }

        localStorage.setItem("remindLog", false);
    }

    function getSessionEmojis() {
        if (currentUserData.sessionData.groupId == 2) {
            axios.get(process.env.REACT_APP_API_URL+"/api/v1/session/"+currentUserData.sessionData.id+"/getEmojiesBysessionProduct")
                .then(res => {
                    console.log('emoji response - ', res);
                    currentUserData.emojis = res.data.responseData;
                    localStorage.setItem('userData', JSON.stringify(currentUserData));
                }).catch(err => {
                    console.log('emoji error - ', err);
                }
            );
            return false;
        }
    }

    window.displayParticipants = function() {

        let participantList = getTempUsers();

        let addObject = {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.INTERACTION, "eventType": "participantList", "userId": currentUserData.id, "details": JSON.stringify({"action":"participantList"}), "timestamp": Util.getCurrentTimestamp()};
        sessionDataStore.addSessionData(addObject);

        let i = 1,
            j = 100;

        participantList.forEach((userData)=>{
            let status = '';

            if ($('#session-users #participant-'+userData.id).length === 0 && userData.userType == 2) {

                let _userEl = '<div class="row text-white user-list" id="participant-'+userData.id+'" data-position="100000000000000">';
                    _userEl += '<div class="col-4 px-2"><p class="mb-0">'+userData.firstName + ' ' + userData.lastName + '</p></div>';
                    _userEl += '<div class="col-3 px-2"><p class="mb-0 text-center" id="cam-'+userData.id+'"></p></div>';
                    _userEl += '<div class="col-2 px-2"><p class="mb-0 text-center" id="mic-'+userData.id+'"></p></div>';
                    _userEl += '<div class="col-3 px-2"><p class="mb-0 text-center" id="status-'+userData.id+'"></p></div>';
                    _userEl += '</div>';

                $('#session-users').append(_userEl);
            }
            
            if (userData.loggedIn === 1) {
                status = 'Waiting';
                $('#participant-'+userData.id).attr('data-position', i++);
            } else {
                status = 'Signed Up';
                $('#participant-'+userData.id).attr('data-position', j++);
            }

            let camAccess = userData.cameraAccess !== undefined ? (userData.cameraAccess == 1 ? 'Granted' : 'Denied') : 'Pending';
            let micAccess = userData.micAccess !== undefined ? (userData.micAccess == 1 ? 'Granted' : 'Denied') : 'Pending';

            $('#cam-'+userData.id).text(camAccess);
            $('#mic-'+userData.id).text(micAccess);
            $('#status-'+userData.id).text(status);
            $('#participant-'+userData.id).removeClass('d-none');
        });

        $('#session-users').find('.user-list').sort(sort_li).appendTo('#session-users');
    }

    function sort_li(a, b) {
      return parseInt($(b).attr('data-position')) < parseInt($(a).attr('data-position')) ? 1 : -1;
    }

    window.getSessionUsers = () => {

        let config = {
                        headers: {
                          "Authorization": currentUserData.token
                        }
                      }

        return new Promise((resolve, reject) => {
                axios.get(process.env.REACT_APP_API_URL+"/api/v1/session/"+currentUserData.sessionData.id+"/users", config)
                    .then(res => {
                        resolve(res.data.responseData);
                    }).catch(err => {
                        console.log('getSessionUsers error ===', err);
                        let addObject = {"sessionId": currentUserData.sessionData.id, "event": "error", "eventType": "api", "userId": currentUserData.id, "details": JSON.stringify({"msg": "getSessionUsers API failed", "error": err}), "timestamp": Util.getCurrentTimestamp()};
                        sessionDataStore.addSessionData(addObject);
                        sessionDataStore.dumpData();
                        reject();
                    }
                );
        });
    }

    window.displayStreamingTimer = () => {

        let duration = parseInt(currentUserData.default.streamRedirectDuration);
        
        countRef = setInterval( function() {
              duration--;

              if(duration <= 0) {
                  clearInterval(countRef);
				          window.showJoinPreStreaming();
              } else {
                  $('#stream-joining-timer').text(duration);
              }
              
        }, 1000 );
		
		    window['sessionCountdownInterval'] = countRef;
    }

	if( window['electron'] )
		{
			setTimeout(() => {
				AgoraRTC.startEchoTestWithInterval(5);
				AgoraRTC.stopEchoTest();
			}, 2000);
		}

    function cameraDetectionError(){
        if (currentUserData.userType == Const.USER_TYPE.HOST) {
			console.log('currentUserData.userType == Const.USER_TYPE.HOST');
			setTimeout( function(){
				$('#camera-detection-alert').modal('show');
			}, 300);
        } else {
			console.log('currentUserData.userType != Const.USER_TYPE.HOST');
            if(currentUserData.sessionData.isCameraRequired == 1) {
                window.mediaAccessAllowed = false;
				setTimeout( function(){
					$('#camera-detection-alert').modal('show');
				}, 300);
				
            } else {
                window.mediaAccessAllowed = false;
				console.log('shoooow4');
                showMediaAccessAlert();
            }
			window['dontHaveAnyCam'](true);
        }

        let addObject = {"sessionId": currentUserData.sessionData.id, "event": "error", "eventType": "error", "userId": currentUserData.id, "details": JSON.stringify({"msg": "No camera detected on device"}), "timestamp": Util.getCurrentTimestamp()};
        sessionDataStore.addSessionData(addObject);
    }

    function micDetectionError() {
        if (currentUserData.userType == Const.USER_TYPE.HOST) {
            $('#mic-detection-alert').modal('show');
        } else {
            window.mediaAccessAllowed = false;
			showMicDetectionAler();
        }

        let addObject = {"sessionId": currentUserData.sessionData.id, "event": "error", "eventType": "microphone", "userId": currentUserData.id, "details": JSON.stringify({"msg": "No microphone detected on device"}), "timestamp": Util.getCurrentTimestamp()};
        sessionDataStore.addSessionData(addObject);
    }

    window.zoomVideo = function(isSkipp) {
        if ( $('#local-media').hasClass('pre-zoom-video1') || isSkipp )
        {
			$('.pre-click-zoom').addClass('d-none');
            $('#local-media').removeClass('pre-zoom-video1');
            $('.pre-click-zoom').find('img').attr('src', 'images/icon-body-focus.png');

            $('#fullbodymsg-one').addClass('d-none');
            $('#fullbodymsg-two').addClass('d-none');
            clearTimeout(msgOne);
            clearTimeout(msgTwo);
			
			$('#canvasWrap').addClass('d-none');
			$('#partToolTip').addClass('d-none');
			
			if ( currentUserData.userType == 2 && window['resetTimer'] )
				{
					window['resetTimer']('r');
					window['resetTimer']('h');
				}
			if ( isSkipp && window['resetWhiteDrawSkip'+currentUserData.id] ) { window['resetWhiteDrawSkip'+currentUserData.id](currentUserData.id); $('#canvasWrap').addClass('d-none'); }
			if ( window['userWhiteboard'][currentUserData.id] && window['nextIsSession'] ) 
				{
					var message = 'preStreamingRoomSetup'+sep+JSON.stringify(window['userWhiteboard'][currentUserData.id].roomSetup.workoutConeLocation);
					window['userWhiteboard'][currentUserData.id].splitRTMSend(currentUserData.sessionData.hostEmail, message);
					
					window['usingPose'] = false;
					window['nextIsSession'](); 
				}
        }
        else
        {
			if ( window['electron'] && ( currentUserData.userType == 2 || currentUserData.isMarketplaceChannel == 1 ) ) { window['changeCameraRes'](window['currentResolution']); }
			if ( window['electron'] && currentUserData.userType == 1 && currentUserData.isMarketplaceChannel == 0) { window['changeCameraRes']('sd'); }
            $('#local-media').addClass('pre-zoom-video1');
            $('.pre-click-zoom').find('img').attr('src', 'images/exit-screen.png');
			//$('.pre-click-zoom').removeClass('d-none');
			if ( window['nextIsSession'] && !window['viewCaptured'+currentUserData.id] )
				{ 
					$('.pre-click-zoom').addClass('d-none');
					$('.skiproomsetupsh').removeClass('d-none');
				}
			else
				{
					//$('.pre-click-zoom').removeClass('d-none');
					$('.skiproomsetupsh').addClass('d-none');
				}
			
			if ( window['eventHR'] )
				{
					window['eventHR'].close();
					window['eventHR'] = false;
				}
			
			if ( currentUserData && currentUserData.sessionData.scriptDetail.length > 0 )
				{
					if ( isFoundEquipment )
						{
							//startRoomSetup();
							
							var waitTime = currentUserData.whiteboardValues.wasButtonWaitTime ? parseInt(currentUserData.whiteboardValues.wasButtonWaitTime) : 1000;
							
							if ( currentUserData.userType == 2 ) { setTimeout(function(){ $('.start_room_button_holder').removeClass('d-none'); }, waitTime); }
							else { $('.start_room_button_holder').removeClass('d-none'); }
						}
				}
        }
    }
	
	function startRoomSetup() {
		var whiteboardValues = currentUserData.whiteboardValues;
		window['globalEquipmentObject'+currentUserData.id] = JSON.parse(whiteboardValues['globalEquipmentObject']);
		
		if ( currentUserData.userType == 2 ) { window['guestUser'] = true; }
		window['preStreamingWhite'] = true;
		window['alreadyPlayedRoomAudio'] = false;
		if ( !window['scriptLoaded'] )
			{
				//loadWhiteboard();
				if ( currentUserData.userType == 2 || currentUserData.sessionData.ondemandId > 0 ) { window['userWhiteboard'][currentUserData.id] = new whiteboard({'user_id': currentUserData.id}); }
				else { window['userWhiteboard'][currentUserData.id] = new whiteboard({'user_id': currentUserData.id, 'host_virtual': true}); }
			}
		
		//if ( !roomSetup.timerRunning ) { roomSetup.startRoomSetup(); }
		
		window.startRoomSetup();
		
		window['scriptLoaded'] = true;
		window['usingPose'] = true;
		
		//var videoElement = $('#local-media').find('video')[0];
		//var videoRatio = videoElement.videoWidth / videoElement.videoHeight;
		
		$('#canvasWrap').removeClass('d-none');
		/* $('#sessionCanvas')[0].width = $('#canvasWrap').width();
		$('#sessionCanvas')[0].height = $('#canvasWrap').width()/videoRatio;
		$('#imageCanvas')[0].width = $('#canvasWrap').width();
		$('#imageCanvas')[0].height = $('#canvasWrap').width()/videoRatio;
		$('#gridCanvas')[0].width = $('#canvasWrap').width();
		$('#gridCanvas')[0].height = $('#canvasWrap').width()/videoRatio; */
		$('#sessionCanvas, #imageCanvas, #gridCanvas').css('background', 'transparent');
		if ( currentUserData && currentUserData.userType && currentUserData.userType == 2 )
			{
				if ( currentUserData.sessionData && currentUserData.sessionData.hostEmail && currentUserData.isMarketplaceChannel && currentUserData.isMarketplaceChannel == 1 )
					{
						let sep = '~@$';
						window['memberState'] = 'joinRoomSetup';
						let msg = RTMConst.MEMBER_ONLINE+sep+window['memberState']+sep+currentUserData.id;
						sendMessage(currentUserData.sessionData.hostEmail, msg);
					}
			}
	}
	
	window['preStreamingSetup'] = startRoomSetup;
	
	window['uploadRoomImg'] = function() {
		  var img = window['roomSetupPicture'];
		  var userId = currentUserData.id;
		  var sessionId = currentUserData['sessionData']['id'];
		
		  var sessionImageData = {
				image : img,
				userId : userId,
				sessionId : sessionId,
				userData: localStorage.getItem("userData")
		  };
		 
		console.log(sessionImageData);
		
		  $.ajax({
			  headers: { 
				  "Content-Type": "application/json; charset=utf-8"
			  },
			  url: Const.BASE_API_PATH+'/api/v1/session/'+currentUserData['sessionData']['id']+'/saveRoomPicture',       
			  dataType: 'json',
			  type: 'post',
			  data: JSON.stringify(sessionImageData),
			  success: function( data, textStatus, jQxhr ){                         
				  console.log(data);
			  },
			  error: function( jqXhr, textStatus, errorThrown ){
				  console.log( errorThrown );
			  }
		  });
	}

	function getWhiteboardValues() {
	console.log('preStreamingController getWhiteboardValues---1');
		var data_op = JSON.parse(localStorage.getItem("userData"));
		$.ajax({headers: {"Content-Type": "application/json; charset=utf-8", "Authorization": data_op.token},
		  url: Const.BASE_API_PATH +'/api/v1/session/whiteboardValues',
		  type: 'post',
		  dataType: 'json',
		  success: function( data, textStatus, jQxhr ) {
	console.log('preStreamingController getWhiteboardValues---2');
			  if ( data.responseData )
				{
	console.log('preStreamingController getWhiteboardValues---3');
					currentUserData.whiteboardValues = data.responseData;
					localStorage.setItem('userData', JSON.stringify(currentUserData));
					window.currentUserData = currentUserData;
				}
	console.log('preStreamingController getWhiteboardValues---4');
		}});
	}

	getWhiteboardValues();

  window.checkHostOnline = () => {
	  
	  
      if ( hasSessionStarted === false ) 
      {
          let i = 0;
		  if ( checkOnlineInterval )
			{
				clearInterval(checkOnlineInterval);
				checkOnlineInterval = null;
			}

          checkOnlineInterval = setInterval(() => {
              if ( newclient != undefined && channel != undefined )
              {
                  if ( i < 3 )
                  {
                      console.log('checkHostOnline - ', i);
                      let text = RTMConst.JOINED + sep;
                      channel.sendMessage({text}).then(() => {
                          console.log('message send successfully on channel------');
                      }).catch(error => {
                          console.log('-------Unable to send channel message------', error);
                      });

                      i++;
                  }
                  else
                  {
                      clearInterval(checkOnlineInterval);
						fetchHostOnlineData();
                  }
              } else {

                  if ( i < 3 )
                  {
                      console.log('checkHostOnline else - ', i);
                      i++;
                  }
                  else
                  {
                      clearInterval(checkOnlineInterval);
                      fetchHostOnlineData();
                  }
              }
          }, 10000);
      }
	  
  }

  function fetchHostOnlineData() {
      let token = JSON.parse(localStorage.getItem('userData')).token;
      axios.defaults.headers.common['Authorization'] = token;
      axios.post(process.env.REACT_APP_API_URL+"/api/v1/session/checkHostOnline", {'sessionId': currentUserData.sessionData.id, 'hostId': currentUserData.sessionData.hostId})
          .then(res => {
              console.log('host online - ', res);

              if ( res.data.responseData.length > 0 )
              {
                  let isSessionStarted = false;
                  res.data.responseData.forEach((sessionData) => {
                      if ( sessionData.message == '222' )
                      {
                          isSessionStarted = true;
                      }
                      else if ( sessionData.message == '305' || sessionData.message == '306' )
                      {
                          isSessionStarted = false;
                      }
                  });

                  if ( isSessionStarted )
                  {
                      axios.post(process.env.REACT_APP_API_URL+"/api/v1/session/triggerHostSSE", {'sessionId': currentUserData.sessionData.id})
                        .then(res => {
                            console.log('Trigger successful');
                           // $('#participant_stuck_msg').modal('show');
                         }).catch(err => {
                            console.log('Trigger SSE not successful');
                           // $('#participant_stuck_msg').modal('show');
                      });
                  }
                  else
                  {
                      setTimeout(() => {
                          window.checkHostOnline();
                      }, 30000);
                  }
              }
              else
              {
                  setTimeout(() => {
                      window.checkHostOnline();
                  }, 30000);
              }
          }).catch(err => {
              setTimeout(() => {
                  window.checkHostOnline();
              }, 30000);
          }
      );
  }

  window.checkHostJoinedRTM = () => {
      if ( hostRTMConnected === false ) 
      {
          let i = 0;
          let checkOnlineInterval = setInterval(() => {
              
              console.log('checkHostJoinedRTM - ', i);

              if ( newclient != undefined && channel != undefined )
              {
                  clearInterval(checkOnlineInterval);
              } 
              else 
              {

                  if ( i < 3 )
                  {
                      i++;
                  }
                  else
                  {
                      clearInterval(checkOnlineInterval);
                      
                      axios.post(process.env.REACT_APP_API_URL+"/api/v1/session/triggerHostSSE", {'sessionId': currentUserData.sessionData.id})
                        .then(res => {
                            console.log('Trigger successful');
                            $('#host_stuck_msg').modal('show');
                         }).catch(err => {
                            console.log('Trigger SSE not successful');
                            $('#host_stuck_msg').modal('show');
                      });
                  }
              }
          }, 10000);
      }
  }

  window.videoDeviceChanged = (deviceId, deviceType, deviceState) => {
      console.log('videoDeviceStateChanged pre----', deviceId, deviceType, deviceState);

      if ( ( osname === "Mac OS" && deviceState == 0 ) || ( deviceState == 1 ) ) // device is pluggedin
      {
          let mediaIds1 = localStorage.getItem(hostlanguage.mediaSetting);
          let mediaIds = JSON.parse(mediaIds1);

          if ( !mediaIds )
          {
            mediaIds = {};
          }
           
          mediaIds.camera = window['cameraValue'];
		  
          localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaIds));
		  
		  applyCameraRestrict();
      }

      window.getDevices();
  }

  window.audioDeviceChanged = (deviceId, deviceType, deviceState) => {
		console.log('audioDeviceStateChanged pre----', deviceId, deviceType, deviceState);

		if ( deviceType == 1 && deviceState == 1 ) // mic is pluggedin
			{
				let mediaIds1 = localStorage.getItem(hostlanguage.mediaSetting);
				let mediaIds = JSON.parse(mediaIds1);

				if ( !mediaIds )
					{
						mediaIds = {};
					}

				mediaIds.microphone = $('#select_microphone').val();
				localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaIds));
			}
		else if ( deviceType == 0 && deviceState == 1 ) // speaker is pluggedin
			{
				let mediaIds1 = localStorage.getItem(hostlanguage.mediaSetting);
				let mediaIds = JSON.parse(mediaIds1);

				if ( !mediaIds )
					{
						mediaIds = {};
					}

				mediaIds.speaker = $('#select_speakers').val();
				localStorage.setItem(hostlanguage.mediaSetting, JSON.stringify(mediaIds));
			}

		if ( deviceState != 16 )
			{
				window.getDevices();
			}
  }
  
  window.hideNoPlaylist = function() {
      $('#no-playlist-found').modal('hide');
      $('#playlist_started_already').modal('hide');
  }
  
  window.changeCameraRes = function(sendVideoInfo) {
	  
	  
	  var profile = Const.HOST_RESOLUTION[sendVideoInfo];
	  
	  console.log('changeCameraRes', sendVideoInfo, profile);
	  
	  if ( profile && profile['res'] )
		{
			window['globalAgora'].agora.setVideoEncoderConfiguration(profile['res']);
			setTimeout(function () { applyCameraRestrict(); }, 2000);
		}
	  else if ( sendVideoInfo == '180p' )
		{
			window['globalAgora'].agora.setVideoEncoderConfiguration({'width': 320, 'height': 180, 'frameRate': 30});
			setTimeout(function () { applyCameraRestrict(); }, 2000);
		}
	 else if ( sendVideoInfo == 'sd' || sendVideoInfo == '360p' )
		{
			window['globalAgora'].agora.setVideoEncoderConfiguration({'width': 640, 'height': 360, 'frameRate': 30});
			setTimeout(function () { applyCameraRestrict(); }, 2000);
		}
	else if ( sendVideoInfo == 'hd' || sendVideoInfo == '720p' )
		{
			window['globalAgora'].agora.setVideoEncoderConfiguration({'width': 1280, 'height': 720, 'frameRate': 30});
			setTimeout(function () { applyCameraRestrict(); }, 2000);
		}
	else if ( sendVideoInfo == 'hdp' || sendVideoInfo == '1080p' )
		{
			window['globalAgora'].agora.setVideoEncoderConfiguration({'width': 1920, 'height': 1080, 'frameRate': 30});
			setTimeout(function () { applyCameraRestrict(); }, 2000);
		}
	else if ( sendVideoInfo == '1440p' )
		{
			window['globalAgora'].agora.setVideoEncoderConfiguration({'width': 2560, 'height': 1440, 'frameRate': 30});
			setTimeout(function () { applyCameraRestrict(); }, 2000);
		}
	else if ( sendVideoInfo == '4kp' )
		{
			window['globalAgora'].agora.setVideoEncoderConfiguration({'width': 3840, 'height': 2160, 'frameRate': 30});
			setTimeout(function () { applyCameraRestrict(); }, 2000);
		}
	
	if ( window['electron'] && currentUserData && currentUserData.userType && currentUserData.userType == 1 && currentUserData.default && currentUserData.default.nativeHostVideoProfile ) 
		{
			var resolutionArray = JSON.parse(currentUserData.default.nativeHostVideoProfile);
			
			for ( var i = 0; i<resolutionArray.length; i++ )
				{
					if ( resolutionArray[i]['type'] == sendVideoInfo )
						{
							if ( resolutionArray[i]['res']['frameRate'] == 60 )
								{
									window['globalAgora'].setVideoRenderFPS(60);
								}
						}
				}
		}
  }
  
  window.changeCameraResOnDemand = (newres) => {
		if ( localStreamOnDemand !== null )
			{
				localStreamOnDemand.getVideoTracks().forEach(function(track) { track.stop(); });
			}
		
		window['currentResolution'] = newres;
		
		window.getDevicesOnDemand();
  }
  
  function applyCameraRestrict() {
	   console.log('prestreaming white cam start');
	  if ( window.whiteCam && window.whiteCam.addOn && window.whiteCam.addOn.CameraChange && window.currentUserData && window.currentUserData.default && parseInt(window.currentUserData.default.useCameraZoomLock) )
		{
			//var currentCamera = $('input[name="video-type"]:checked').val();
			var currentCamera = '';
			if ( window['cameraValue'] )
				{
					currentCamera = window['cameraValue'];
				}
			if( currentCamera )
				{
					window.whiteCam.addOn.CameraChange(currentCamera);
					console.log('prestreaming white cam changed---', currentCamera);
				}
		}
  }
  

  window['globalRTM'] = sendMessage;

  function sendMessageToChannel(text)
  {
      console.log('###Send message to Channel: ' + currentUserData.email + ' | text: ' + text);

      channel.sendMessage({text}).then(() => {
          retryCounter = 0;
      }).catch(error => {
        console.log('channel message failed----', error);

        if (retryCounter <= 3) {
            retryCounter++;
            sendMessageToChannel(text);
        } else {
            retryCounter = 0;
        }
      });
  }

  window['sendMessageToChannel'] = sendMessageToChannel;

  function getUserDetails(email) {
      let userList = getTempUsers();
      let userDetails = null;

      userList.forEach((userData) => {
          if ( userData.email == email) 
          {
              userDetails = userData;
          }
      });

      return userDetails;
  }

  window.electronCameraError = (code) => {
      let text = 'The local video capturing device is in use';

      if (code == 1) 
      {
          text = 'No specified reason for the local video failure';
      }
      else if (code == 2) 
      {
          text = 'No permission to use the local video capturing device';
      }
      else if (code == 8) 
      {
		  console.log('cameraDetectionError');
          cameraDetectionError();
          text = 'The SDK cannot find the local video capture device';
      }

      let addObject = {"sessionId": currentUserData.sessionData.id, "event": "error", "eventType": "camera", "userId": currentUserData.id, "details": JSON.stringify({"msg": text}), "timestamp": Util.getCurrentTimestamp()};
      sessionDataStore.addSessionData(addObject);
  }

  window.captureElectronError = (eventType, errMsg) => {
      let addObject = {"sessionId": currentUserData.sessionData.id, "event": "error", "eventType": eventType, "userId": currentUserData.id, "details": JSON.stringify({"msg": errMsg}), "timestamp": Util.getCurrentTimestamp()};
      sessionDataStore.addSessionData(addObject);
  }
  
  window.setUserProfilePrestreaming = (profileType) => {
		var profile = Const.HOST_RESOLUTION[profileType];
		if(stream1 != undefined && stream1 != null && !window['electron'] )
			{
				if(stream1.length > 0)
					{
						for ( var i = 0; i<stream1.length; i++ )
							{
								stream1[i].setVideoProfile(profile);
							}
					}
    		}
		
		if ( window['changeCameraRes'] && window['globalAgora'] && window['globalAgora'].agora ) { window['changeCameraRes'](profileType); }
  }
  
  window.enterSession = function() {
		$('#local-media').removeClass('pre-zoom-video1');

		$('#fullbodymsg-one').addClass('d-none');
		$('#fullbodymsg-two').addClass('d-none');
		
		$('#canvasWrap').addClass('d-none');
		$('#partToolTip').addClass('d-none');
		
		if ( window['userWhiteboard'][currentUserData.id] && window['nextIsSession'] ) 
			{
				var message = 'preStreamingRoomSetup'+sep+JSON.stringify(window['userWhiteboard'][currentUserData.id].roomSetup.workoutConeLocation);
				window['userWhiteboard'][currentUserData.id].splitRTMSend(currentUserData.sessionData.hostEmail, message);
				
				window['usingPose'] = false;
				window['nextIsSession'](); 
			}
    }
	
  function setWorkoutValues(equipmentLocation, usrId) {
		if ( equipmentLocation['bagLocation'] ) { window['bagAttributes'+usrId] = JSON.parse(equipmentLocation['bagLocation']); window['alreadyDrawnBag'+usrId] = true; }
		if ( equipmentLocation['coneLocation'] ) { window['coneAttributes'+usrId] = JSON.parse(equipmentLocation['coneLocation']); window['alreadyDrawnCone'+usrId] = true; }
		if ( equipmentLocation['diagConeLocation'] ) { window['coneAttributesDiag'+usrId] = JSON.parse(equipmentLocation['diagConeLocation']); window['alreadyDrawnConeDiagonal'+usrId] = true; }
		if ( equipmentLocation['ladderLocation'] ) { window['ladderAttributes'+usrId] = JSON.parse(equipmentLocation['ladderLocation']); window['alreadyDrawnLadder'+usrId] = true; }
		//if ( equipmentLocation['plankLocation'] ) { window['plankAttributes'+usrId] = JSON.parse(equipmentLocation['plankLocation']); window['alreadyDrawnPlank'+usrId] = true; }
		
		if ( equipmentLocation['workoutConeLocation'] ) { window['workoutConePlacing'+usrId] = JSON.parse(equipmentLocation['workoutConeLocation']); }
	}
  
  function updateWorkoutPosition(usrId, statement, value) {
	  if ( value )
		{
			axios.post(process.env.REACT_APP_API_URL+"/api/v1/user/getBoxingPosition", { 'userId': usrId, 'equipmentStatement': statement, 'value': value }).then(res => {
				var equipmentLocation = res.data.responseData;
				setWorkoutValues(equipmentLocation, usrId);
			}).catch(err =>{ console.log('err'); }); 
		}
	  else
		{
			axios.post(process.env.REACT_APP_API_URL+"/api/v1/user/getBoxingPosition", { 'userId': usrId, 'equipmentStatement': statement  }).then(res => {
				var equipmentLocation = res.data.responseData;
				setWorkoutValues(equipmentLocation, usrId);
			}).catch(err =>{ console.log('err'); }); 
		}
	}
	
	updateWorkoutPosition(currentUserData.id, 'hostInfo');
	window['updateWorkoutPosition'] = updateWorkoutPosition;
	
	window.getDevicesOnDemand = () => {
		var device;
		let that = this;
		let defaultSetting = '';
		var cameraSet = false;
		var index = 0;
		let cameraDevicesArray = [];
		
		if ( globalCameraId == null ) 
			{
				let vdoMediaList = '';
				$('#video-media-content').html('');
				$('#cameraSelect').html('');
				//$('#camera-list').html('');	
				
				navigator.mediaDevices.enumerateDevices().then(function(devices) {
					var isMarketplaceChannel = JSON.parse(localStorage.getItem('userData')).isMarketplaceChannel;
					var WASRequiredInWaitingLounge = parseInt(JSON.parse(localStorage.getItem('userData')).default.WASRequiredInWaitingLounge);
					var videoMain;
					if ( isMarketplaceChannel == 1 && WASRequiredInWaitingLounge == 1 )
						{
							videoMain = '<div class="turning_video_title">Camera</div><div class="for_cameras_cbx camera_main_holder" id="camera_cbx"></div><div class="for_cameras_main" id="video_camera"><div class="prestreaming_nocam d-none"><div class="muted_ps"></div></div><div id="local-media"><small class="pre-click-zoom d-none" data-toggle="tooltip" title="Zoom" onClick="zoomVideo()"><img src="images/icon-body-focus.png" /></small></div></div>';
						}
					else 
						{
							videoMain = '<div class="turning_video_title">Camera</div><div class="for_cameras_cbx camera_main_holder" id="camera_cbx"></div><div class="for_cameras_main" id="video_camera"><div class="prestreaming_nocam d-none"><div class="muted_ps"></div></div><div id="local-media"><div class="continue_allowed skiproomsetupsh d-none" onClick="zoomVideo(true)">SKIP</div><small class="pre-click-zoom d-none" data-toggle="tooltip" title="Zoom" onClick="zoomVideo()"><img src="images/icon-body-focus.png" /></small></div></div>';
						}
					$('#video-media-content').html(videoMain);
					window['devicesLoaded'] = true;
					
					var whiteboardCanvas = '<div id="canvasWrap" class="canvasHold centerCanvas d-none"><canvas class="canvasDraw" id="sessionCanvas" width="1280" height="720"></canvas><canvas class="canvasGrid canvasImage" style="left: 0 !important" id="imageCanvas" width="1280" height="720"></canvas><canvas class="canvasImage" id="bufferCanvas" width="640" height="360"></canvas><div id="workoutAreaButton" className="workoutButton d-none">T <br/> A <br/> P</div></div><span id="partToolTip" class="room_capturing_popup bg-grayy rounded d-none"><span class="separate_stats tool_tip_inner"><span class="tooltipSuccess d-none"><svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></span><svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 20 130 80" class="tooltipSvg d-none"><polyline id="v_shape" points="5 -10 50 60 80 60 125 -10" stroke="white" fill="transparent" stroke-width="20"/><defs><linearGradient id="progress"><stop id="stop1" offset="0" stop-color="rgb(32, 205, 243)"/><stop id="stop2" offset="0" stop-color="white"/></linearGradient></defs></svg><div class="tooltipImage"></div><div id="upNextText" class="up_next d-none"></div><div class="tooltipText rounded"></div><div id="innerPartText" class="part_inner"></div><div id="walkToolImage" class="walk_tool_hold d-none"><div class="walk_tool_image"></div><div class="walk_tool_text"></div></div><div class="tooltipNumber d-none"></div></span><span id="progressBarRoom" class="separate_stats d-none"></span></span><span id="heightToolTip" class="screen_popup room_capturing_popup height_tip d-none"><div id="heightProgressBar"><div class="tooltipText rounded progress_bar_percent"><span id="progressHeightNum">0</span><span id="percentProgress">%</span></div><div id="heightProgress"></div></div><div class="heightTipText bg-grayy rounded stand_still_box">Stand still <span class="separate_stats">Capturing height</span></div></span><video id="local_preview" autoplay playsinline></video>';
					$('#local-media').append(whiteboardCanvas).addClass('ondemandLocalMedia');
					
					
				  devices.forEach(function(device) {
					if ( device.kind === 'videoinput' )
						{
							if ( !device.label || device.label == '' || device.label == null || device.label == undefined )
								{
									var cameraNum = index + 1;
									device.label = 'Camera '+cameraNum;
								}
							
							defaultSetting = '';
							if ( !cameraSet )
								{
									globalCameraId = device.deviceId;
									defaultSetting = 'checked';
									
									window['cameraValue'] = globalCameraId;
								}
								
							cameraSet = true;
							
							vdoMediaList = '<div class="check-camera-audience"><input type="radio" class="form-radio" name="video-type" id="lbl-'+index+'" data-keyid="'+index+'" value="'+device.deviceId+'" '+ defaultSetting +'><label for="lbl-'+index+'"> '+ device.label +'</label></div></div>';
							
							//$('#camera-list').append(vdoMediaList);
							
							let deviceValue = device.deviceId;;
							let deviceObject = {'label': device.label, 'value': deviceValue };	
							
							$("#cameraSelect").append('<option  data-keyid='+index+' value='+index+'>'+device.label+'</option>');
							
							cameraDevicesArray.push(deviceObject);
							
							index++;
						}
				  });
				})
				.catch(function(err) {
				  console.log(err.name + ": " + err.message);
				});
				
				newCameraArray = cameraDevicesArray;
				window['newCameraArrayList'] = cameraDevicesArray;
			}
			
		var constraints = {
				audio: false,
				video: {
					width: 640,
					height: 360,
					aspectRatio: 16/9,
					deviceId: globalCameraId
			  }
		  };
		  
		if ( window['currentResolution'] && window['currentResolution'] !== '' )
			{
				if ( window['currentResolution'] === 'sd' )
					{
						constraints.video.width = { ideal: 640 };
						constraints.video.height = { ideal: 360 };
					}
					
				if ( window['currentResolution'] === 'hd' )
					{
						constraints.video.width = { ideal: 1280 };
						constraints.video.height = { ideal: 720 };
					}
					
				if ( window['currentResolution'] === 'hdp' )
					{
						constraints.video.width = { ideal: 1920 };
						constraints.video.height = { ideal: 1080 };
					}
			}	
		
		console.log('getDevicesOnDemand constraints', constraints);
		
		if( globalCameraId || chrome)
			{
				navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
					onUserMediaSuccess(stream);
					//that.setState({streamError: false});
					var preview = document.getElementById("local_preview");
					preview.srcObject = stream;
					if (streamStatus && !is_ffox )
						{
							preview.play();
							streamStatus = false;
						}
					
					/* that.onUserMediaSuccess(stream);
					that.setState({streamError: false});
					var preview = document.getElementById("local_preview");
					preview.srcObject = stream;
					if (that.state.streamStatus && !is_ffox )
						{
							preview.play();
							that.state.streamStatus = false;
						} */
				}).catch(function (error) { console.log("Something went wrong!", error); });
			}
	}
	
	function onUserMediaSuccess(stream) {
		console.log('NEW STREAM---', stream);
		window['localStreamOnDemandGlobal'] = stream;
		localStreamOnDemand = stream;
		streamStatus = true;
	  }
}

export default preStreaming;